import _ from 'lodash'
import { getAxios } from './projectAxios'
import { List, Map, fromJS, isImmutable } from 'immutable'
import { InfoBoxFields } from '../constants/InfoBoxFields'
import { WidgetListFields } from '../constants/WidgetListFields'
import { getDisplayType } from '../constants/getDisplayType'
import { COUNTER_MODE_COUNT, COUNTER_MODE_INTERVAL } from '../constants/COUNTER_MODE_COUNT'
import { getGridData } from '../constants/getGridData'
import { CALENDAR_EVENT_TYPE, filterEditableParametersJS, fixActionID, fixID, toJS } from '../lib/common'
import {
  ExtendedGalleryFields,
  ADDRESS_FIELDS,
  eProductListFields,
  eProductSlidesFields,
  CART_ITEM_KEYS,
  TablePricingFields,
} from '../constants/GalleryGridFields'
import { eProductFields } from '../constants/eProductFields'
import { filterEditableParameters, getElemName, option } from '../lib/common'
import { LIST_BASED_FIELDS } from '../constants/LIST_BASED_FIELDS'
import { SLACK_BOT_TYPE, SURVEY_EMAIL_TYPE, SURVEY_TYPE, WORKFLOW_TYPE } from '../constants/features'
import { getCommandElementLabel } from '../components/Project/SlackBot/utils'
import { getSalseForceFieldType, getSFFieldType } from './getSalseForceFieldType'
import { getRootParent } from '../store/project/getRootParent'
import { SKIP_IS_FIRST_LAST_TYPES } from './tab-utils'
import { getParentIdInModal } from '../constants/toUnits'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { collectParentChildrenCount } from '../components/WidgetBuilder/UI/Components/useComponentTabOrder'
import { getVarHash } from '../store/utils'
import { isSame } from '../components/WidgetBuilder/UI/isSame'

export const getParentPowerColumns = (
  state,
  parentColumns,
  tableColumns,
  elemUID,
  isRepeat = false,
  repeatUID = null,
  targetType = 'PowerTable',
  defaultTag = ''
) => {
  let result = [...parentColumns]

  const dialogStateUID = state.getIn(['panels', 'confWidgetEl', 'uid'], null)

  const pageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get?.('uid')
  let isProject = Boolean(state.getIn(['project', 'Settings', 'elements', elemUID, 'type']))
  let parent = getParentIdInModal(state, elemUID, isProject)
  if (!isProject && dialogStateUID) {
    isProject = Boolean(state.getIn(['project', 'Settings', 'elements', dialogStateUID, 'type']))
    parent = getParentIdInModal(state, dialogStateUID, isProject)
  }

  const push = (value, label, group = `view:${uid}`) =>
    result.push({
      value,
      label: _.trim(isRepeat ? `${repeatLabel} / ${label}` : label),
      uid: elemUID,
      group,
    })

  const valueStart = isRepeat
    ? `${isProject ? parent : pageUID}:${repeatUID}:${elemUID}`
    : `${isProject ? parent : pageUID}:${elemUID}`

  const tag = ` ${defaultTag || ''}`
  push(`${valueStart}:value`, `[${targetType} / Value]${tag}`, 'PowerTableWidget:' + elemUID)

  push(`${valueStart}-selectedItems`, `[${targetType} / Selection]${tag}`, 'formWidget:' + elemUID)

  push(`${valueStart}-PowerTableBatchChanged`, `[${targetType} / Batch Changed]${tag}`, 'formWidget:' + elemUID)
  push(`${valueStart}-PowerTableBatchCompleted`, `[${targetType} / Batch Completed]${tag}`, 'formWidget:' + elemUID)
  push(`${valueStart}-PowerTableBatchResult`, `[${targetType} / Batch Result Values]${tag}`, 'formWidget:' + elemUID)
  push(`${valueStart}-PowerTableBatchSuccess`, `[${targetType} / Batch Success Values]${tag}`, 'formWidget:' + elemUID)
  push(`${valueStart}-PowerTableBatchFailed`, `[${targetType} / Batch Failed Values]${tag}`, 'formWidget:' + elemUID)

  push(`${valueStart}-totalRows`, `[${targetType} / Total Rows]${tag}`, 'formWidget:' + elemUID)
  push(`${valueStart}:selected`, `[${targetType} / Row Selection Status]${tag}`, 'PowerTableWidget:' + elemUID)

  const processColumn = (col) => {
    if (_.size(_.get(col, 'columns', [])) === 0) {
      if (_.get(col, ['meta', 'role']) === 'field') {
        push(`${valueStart}:${col.id}`, `[${targetType} / ${col.Header || 'Col'}]${tag}`, 'PowerTableWidget:' + elemUID)
      }
    } else {
      // console.log(">>>", 'add sub cols',_.get(col, ['meta', 'subCtrl', 'Type'], 'PowerTable'), )
      if (_.get(col, ['meta', 'subCtrl', 'Type'], 'PowerTable') === 'PowerTable') {
        push(
          `${valueStart}:${col.id}:value`,
          `[${col.Header || 'Col'}] / [PowerTable / Value]${tag}`,
          'PowerTableWidget:' + elemUID
        )
        //     push(`${valueStart}:${col.id}-selectedItems`, `[${col.Header || 'Col'}] / [PowerTable / Selection]${tag}`, 'formWidget:' + elemUID)
        //     push(`${valueStart}:${col.id}-totalRows`, `[${col.Header || 'Col'}] / [PowerTable / Total Rows]${tag}`, 'formWidget:' + elemUID)
      }
      _.each(_.get(col, 'columns', []), processColumn)
    }
  }

  _.each(tableColumns.toJS(), processColumn)

  return result
}

let profileCache = null

export const getUserProfile = (isLicStat = false) => {
  if (profileCache) {
    return profileCache
  } else {
    profileCache = _getUserProfile(isLicStat)
    return profileCache
  }
}

const _getUserProfile = async (isLicStat = false) => {
  const axios = getAxios()
  try {
    const { data, status } = await axios.get(
      '/FormBuilder/user/getUserInfo?_t=' + Math.random() * 10000 + (isLicStat ? '&isLicStat=true' : '')
    )
    if (status === 200) {
      let licenseName
      let role = ''
      if (data.license_id == 5 || data.parentName) {
        let parentName = ''
        if (data.parentName) {
          parentName = data.parentName + ' : '
        }
        if (data.isTrial == true) {
          licenseName = 'Trial -'
          role = 'Trial'
        } else {
          licenseName = 'Free -'
          role = 'Free'
        }
        if (data.isPowerUser) {
          licenseName = parentName + 'Power User'
          role = 'Power User'
        } else if (data.isAllowCreate) {
          licenseName = parentName + 'Creator'
          role = 'Creator'
        } else if (data.isEditor) {
          licenseName = parentName + 'Editor'
          role = 'Editor'
        } else if (data.isColobrators) {
          licenseName = parentName + 'Collaborator'
          role = 'Collaborator'
        } else {
          licenseName = 'Free'
        }
        if (data.parentLicenseName) {
          licenseName = data.parentLicenseName
        }
      } else {
        licenseName = data.license_name
        role = 'Owner'
      }
      let isFirstModal = data.isShowNeedHelp && !data.parentUserID
      let isEncrypted = false
      if (data.parentUserID) {
        isEncrypted = data.isEncryptedParent
      } else {
        isEncrypted = Boolean(data.EncryptAccount)
      }

      let UserName = '',
        fullName
      if (data.firstName || data.lastName) {
        UserName = `${data.firstName} ${data.lastName}`
      } else {
        UserName = `${data.UserEmail}`
      }
      fullName = UserName
      if (_.get(data, ['commercialInfo', 'envName'])) {
        fullName += ` [${_.get(data, ['commercialInfo', 'envName'])}]`
      } else {
        if (data.parentUserID) {
          fullName += ` [${data.parentName}]`
        } else {
          fullName += ` [${data.UserName}]`
        }
      }

      return {
        ...data,
        isFirstModal: isFirstModal,
        token: data.token,
        IsLogoAvailable: data.IsLogoAvailable,
        allowWeb: data.allowWeb ? true : false,
        allowTitanSign: data.isTrial || data.allowTitanSign,
        userID: data.userID,
        license_name: licenseName,
        originLicenseName: data.license_name,
        PSLeft: data.PSLeft,
        UserName: `${UserName}`,
        UserDomain: `${data.parentName || data.UserName}`,
        FullName: fullName,
        DefaultTimeZone: data.DefaultTimeZone,
        parentUserID: data.parentUserID,
        parentName: data.parentName,
        license_id: data.license_id,
        isNeedParent: data.isNeedParent,
        isPowerUser: data.isPowerUser,
        firstName: data.firstName,
        lastName: data.lastName,
        isMultipleParent: data.isMultipleParent,
        isAdmin: data.isAdmin === 1,
        role,
        UserEmail: data.UserEmail,
        account: data.parentName ? data.parentName : data.UserEmail,
        _UserName: data.UserName,
        googleAnalytics: data.googleAnalytics,
        DefaultLanguageID: data.DefaultLanguageID,
        DefaultTimeZone: data.DefaultTimeZone,
        newsLetter: data.newsLetter,
        IsNotifySignIn: data.IsNotifySignIn,
        license: data.license,
        stat: data.stat,
        parentPlatform: data.parentPlatform,
        EncryptAccount: isEncrypted,
        isAllowCreate: data.isAllowCreate,
        isEditor: data.isEditor,
        isTrial: data.isTrial,
        unsubscribe: data.unsubscribe,
        allowSupportWidget: true,
      }
    }
  } catch (err) {
    // console.error(err);
  }
  return {}
}

/**
 * Get AI consent status for the current user
 * @returns {Promise<{hasConsented: boolean, consentedAt: string|null}>}
 */
export const getAIConsent = async () => {
  const axios = getAxios()
  try {
    const { data, status } = await axios.get('/FormBuilder/user/getAIConsent')
    if (status === 200) {
      return {
        hasConsented: data.hasConsented === true,
        consentedAt: data.consentedAt || null,
      }
    }
  } catch (err) {
    console.error('Error fetching AI consent:', err)
  }
  return {
    hasConsented: false,
    consentedAt: null,
  }
}

/**
 * Set AI consent for the current user
 * @returns {Promise<{status: boolean, hasConsented: boolean, consentedAt: string|null}>}
 */
export const setAIConsent = async () => {
  const axios = getAxios()
  try {
    const { data, status } = await axios.post('/FormBuilder/user/setAIConsent')
    if (status === 200) {
      return {
        status: data.status === true,
        hasConsented: data.hasConsented === true,
        consentedAt: data.consentedAt || null,
      }
    }
  } catch (err) {
    console.error('Error setting AI consent:', err)
  }
  return {
    status: false,
    hasConsented: false,
    consentedAt: null,
  }
}

export const buildElementLabel = (tag, type, prop) => {
  if (_.trim(tag)) {
    if (prop) {
      return _.trim(`${tag} / ${prop}`)
    }
    return _.trim(tag)
  }
  if (prop) {
    return _.trim(`${type} / ${prop}`)
  } else {
    return _.trim(type)
  }
}

const filterRecursiveChildren = (list, parentUID) => {
  return _.filter(list, (child) => {
    if (_.isArray(child)) {
      return _.filter(child, (id) => id !== parentUID)
    } else {
      return child !== parentUID
    }
  })
}

const getElementMappingData = (
  child,
  id,
  uid,
  page,
  isRepeat = false,
  repeatUID,
  repeatLabel = 'Repeat',
  isInCondition = false,
  elements = [],
  isSurvey,
  extraLabel = '',
  activeStep
) => {
  let ret = []
  if (String(id).indexOf('fit_') > -1) {
    return ret
  }
  if (activeStep == 'picklist') {
    if (child.type == 'FormField' && ['select', 'multiSelect'].indexOf(_.get(child, ['props', 'control'])) > -1) {
      isRepeat = false
    }
  }
  const buildElementLabel = (tag, type, prop) => {
    if (!tag && isSurvey) {
      let component = page.getIn(['Props', 'elements', id])
      if (component && component.get('type') != 'PageConditionalForm"') {
        let parentC = page.getIn(['Props', 'elements', component.get('parent')])
        if (parentC && parentC.getIn(['type']) == 'PageConditionalForm') {
          let tabs = parentC.getIn(['props', 'lg', 'tabs'], List())
          let slideIndex = 1
          tabs.map((tab) => {
            let questionIndex = tab.get('children', List()).indexOf(id)
            if (questionIndex > -1) {
              let slideName = tab.get('label')
              if (!slideName) {
                slideName = `Slide ${slideIndex}`
              }
              let title = tab.getIn(['info', id, 'title'], '')
              if (!title) {
                title = getDisplayType(child.type)
              }
              tag = slideName + '.' + title
            }
            if (!tab.get('isStart')) {
              slideIndex++
            }
          })
        }
      }
    }
    if (tag) {
      if (prop) {
        return `${tag} / ${prop}`
      }
      return tag
    }
    if (prop) {
      return `${type} / ${prop}`
    } else {
      return type + ` (${id})`
    }
  }

  const push = (value, label, group = `view:${uid}`, customType) => {
    if (!group) {
      group = `view:${uid}`
    }
    ret.push({
      value,
      label: isRepeat ? `${repeatLabel} / ${label}` : label,
      uid: id,
      group,
      type: child.type,
      subType: customType || _.get(child, 'props.control'),
    })
  }

  const valueStart =
    uid === 'project'
      ? `${_.get(child, 'parent', 'project')}:${id}`
      : isRepeat
        ? `${uid}:${repeatUID}:${id}`
        : `${uid}:${id}`
  const noRepeatValueStart = uid === 'project' ? `${_.get(child, 'parent', 'project')}:${id}` : `${uid}:${id}`

  const rawTag = _.get(child, 'props.tag', '') ? _.get(child, 'props.tag', '') : ''
  let tag = ''
  if (rawTag) {
    tag = `${rawTag}`
  } else if (_.get(child, 'props.lg.label', '')) {
    tag = `${_.get(child, 'props.lg.label', '')}`
  } else if (_.get(child, 'props.lg.text', '')) {
    if (_.get(child, 'type') == 'Typography' && _.get(child, 'props.lg.isHTML')) {
      tag = ''
    } else {
      tag = `${_.get(child, 'props.lg.text', '')}`
    }
  }
  switch (child.type) {
    case 'VerticalCard':
      _.each(child?.props?.columns, (column) => {
        _.each(child?.props?.items, (item) => {
          push(
            `${valueStart}:${column.id}:${item.id}`,
            buildElementLabel(tag, getDisplayType(child.type), `${column.label} / ${item.label}`)
          )
        })
      })
      break
    case 'InteractiveImage':
      push(`${valueStart}:value`, buildElementLabel(tag, getDisplayType(child.type), 'Mark Value'))
      push(`${valueStart}:label`, buildElementLabel(tag, getDisplayType(child.type), 'Mark Label'))
      push(`${valueStart}:top`, buildElementLabel(tag, getDisplayType(child.type), 'Mark Top Position'))
      push(`${valueStart}:left`, buildElementLabel(tag, getDisplayType(child.type), 'Mark Left Position'))
      push(`${valueStart}-size`, buildElementLabel(tag, getDisplayType(child.type), 'Total Marks'))
      push(`${valueStart}-src`, buildElementLabel(tag, getDisplayType(child.type), 'Image Source'))
      push(`${valueStart}-value`, buildElementLabel(tag, getDisplayType(child.type), 'Image Current Value'))
      push(`${valueStart}-label`, buildElementLabel(tag, getDisplayType(child.type), 'Image Current Label'))
      push(`${valueStart}-left`, buildElementLabel(tag, getDisplayType(child.type), 'Image Current Left'))
      push(`${valueStart}-top`, buildElementLabel(tag, getDisplayType(child.type), 'Image Current Top'))
      push(`${valueStart}-imgBase64`, buildElementLabel(tag, getDisplayType(child.type), 'Image Base64'))
      push(`${valueStart}-imgHtml`, buildElementLabel(tag, getDisplayType(child.type), 'Image HTML'))
      push(`${valueStart}-file`, buildElementLabel(tag, getDisplayType(child.type), 'Image File'))
      push(`${valueStart}-fileWithMark`, buildElementLabel(tag, getDisplayType(child.type), 'Image File With Marks'))
      break
    case 'ExternalLookup':
      push(`${valueStart}:search`, buildElementLabel(tag, getDisplayType(child.type), 'Search'))
      push(`${valueStart}:value`, buildElementLabel(tag, getDisplayType(child.type), 'Value'))
      push(`${valueStart}:label`, buildElementLabel(tag, getDisplayType(child.type), 'Label'))
      break
    case 'DiffViewer':
      push(`${valueStart}:left`, buildElementLabel(tag, getDisplayType(child.type), 'Old'))
      push(`${valueStart}:right`, buildElementLabel(tag, getDisplayType(child.type), 'New'))
      break
    case 'TextReview':
      push(valueStart, buildElementLabel(tag, getDisplayType(child.type)))
      push(`${valueStart}:old`, buildElementLabel(tag, getDisplayType(child.type), 'Old'))
      push(`${valueStart}:new`, buildElementLabel(tag, getDisplayType(child.type), 'New'))
      push(`${valueStart}:draft`, buildElementLabel(tag, getDisplayType(child.type), 'Draft'))
      push(`${valueStart}:value`, buildElementLabel(tag, getDisplayType(child.type), 'Value'))
      push(`${valueStart}:changesNumber`, buildElementLabel(tag, getDisplayType(child.type), 'Number of Changes'))
      break
    case 'BarcodeGenerator':
    case 'AddressFinder':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      break
    case 'ECommerceCatalogue': {
      _.each(eProductListFields, ({ key, label }) => {
        push(`${valueStart}:${key}`, buildElementLabel(tag, 'ECommerceCatalogue', label))
      })
      break
    }
    case 'ECommerceProduct': {
      _.each(eProductFields, ({ key, label }) => {
        push(`${valueStart}:${key}`, buildElementLabel(tag, 'ECommerceProduct', label))
      })
      _.each(eProductSlidesFields, ({ key, label }) => {
        push(`${valueStart}:${key}`, buildElementLabel(tag, 'ECommerceProduct Slide', label))
      })
      break
    }
    case 'InteractiveDocument': {
      if (activeStep === 'WorkFlow') {
        push(`${valueStart}:ft_fileupload_docx`, buildElementLabel(tag, `InteractiveDocument`, 'DOCX'))
      } else {
        push(`${valueStart}:srcEdit`, buildElementLabel(tag, `InteractiveDocument`, 'Source'))
      }
      break
    }
    case 'BarcodeReader': {
      push(`${valueStart}:text`, buildElementLabel(tag, `BarcodeReader`, 'Button Text'))
      // push(`${valueStart}:status`, buildElementLabel(tag, `BarcodeReader`, 'Scan Status'))
      push(`${valueStart}:value`, buildElementLabel(tag, `BarcodeReader`, 'Value'))
      push(`${valueStart}:valueType`, buildElementLabel(tag, `BarcodeReader`, 'Value Type'))
      break
    }
    case 'GoogleMap': {
      push(`${valueStart}:selLat`, buildElementLabel(tag, `GoogleMap`, 'Selected Latitude'))
      push(`${valueStart}:selLng`, buildElementLabel(tag, `GoogleMap`, 'Selected Longitude'))
      push(`${valueStart}:selValue`, buildElementLabel(tag, `GoogleMap`, 'Selected Value'))
      push(`${valueStart}:selText`, buildElementLabel(tag, `GoogleMap`, 'Selected Text'))
      push(`${valueStart}:lat`, buildElementLabel(tag, `GoogleMap`, 'Marker Latitude'))
      push(`${valueStart}:lng`, buildElementLabel(tag, `GoogleMap`, 'Marker Longitude'))
      push(`${valueStart}:value`, buildElementLabel(tag, `GoogleMap`, 'Marker Value'))
      push(`${valueStart}:text`, buildElementLabel(tag, `GoogleMap`, 'Marker Text'))
      push(`${valueStart}:color`, buildElementLabel(tag, `GoogleMap`, 'Marker Pin Color'))
      push(`${valueStart}:address`, buildElementLabel(tag, `GoogleMap`, 'Marker Address'))
      push(`${valueStart}:zoom`, buildElementLabel(tag, `GoogleMap`, 'Zoom'))
      _.each(_.get(child, 'props.pins', []), (pin, index) => {
        push(
          `${valueStart}:pins:${index}:value`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Value`)
        )
        push(
          `${valueStart}:pins:${index}:lat`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Latitude`)
        )
        push(
          `${valueStart}:pins:${index}:lng`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Longitude`)
        )
        push(
          `${valueStart}:pins:${index}:text`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Marker Text`)
        )
        push(
          `${valueStart}:pins:${index}:color`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Color`)
        )
        push(
          `${valueStart}:pins:${index}:address`,
          buildElementLabel('Pin', `GoogleMap`, `${_.capitalize(pin.text)} / Address`)
        )
      })
      break
    }
    case 'DateRange': {
      push(`${valueStart}:startDate`, buildElementLabel(tag, `DateRange`, 'Start Date'))
      push(`${valueStart}:endDate`, buildElementLabel(tag, `DateRange`, 'End Date'))
      push(`${valueStart}-formattedValue`, buildElementLabel(tag, `DateRange`, 'Formatted Value'))
      break
    }
    case 'YouTube': {
      if (child?.props?.allowEvents) {
        push(`${valueStart}-status`, buildElementLabel(tag, `YouTube`, 'Status'))
        push(`${valueStart}-time`, buildElementLabel(tag, `YouTube`, 'Time'))
      }
      if (!isInCondition) {
        push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type), 'SRC'))
      }
      break
    }
    case 'Capture': {
      let prefix = 'Capture'
      push(`${valueStart}`, buildElementLabel(tag, `${prefix} / Capture`, 'File'))
      push(`${valueStart}-files`, buildElementLabel(tag, `${prefix} / Capture`, 'File Name'))
      break
    }
    case 'FormField': {
      let prefix = 'FormField'
      if (child.parent) {
        let parent = page.getIn(['Props', 'elements', child.parent])
        if (parent) {
          if (['Section', 'Stack', 'Form'].indexOf(parent.get('type')) > -1) {
            if (parent.getIn(['props', 'tag'])) {
              prefix = parent.getIn(['props', 'tag'])
            }
          }
        }
      }
      const control = _.capitalize(getDisplayType(_.get(child, 'props.control', 'text')))
      if (_.get(child, 'props.control', 'text') === 'lookup') {
        push(`${valueStart}:ft_value`, buildElementLabel(tag, `${prefix} / ${control}`, 'Value'))
        push(`${valueStart}:ft_text`, buildElementLabel(tag, `${prefix} / ${control}`, 'Text'))
        push(`${noRepeatValueStart}:ft_search`, buildElementLabel(tag, `${prefix} / ${control}`, 'Search Text'))
      } else if (LIST_BASED_FIELDS.indexOf(_.get(child, 'props.control', 'text')) > -1) {
        let labelPrefix = isRepeat ? `${repeatLabel} / ` : ''
        let rList = [
          {
            value: `${valueStart}:ftListValue`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Value'),
            group: `view:${uid}`,
            type: child.type,
            subType: _.get(child, 'props.control', 'text'),
            uid: id,
          },
          {
            value: `${valueStart}:ftListLabel`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Label'),
            group: `view:${uid}`,
            type: child.type,
            subType: _.get(child, 'props.control', 'text'),
            uid: id,
          },
        ]
        if (_.get(child, 'props.control', 'text') === 'buttongroup' && child?.props?.source === 'sf') {
          rList.push({
            value: `${valueStart}:ftListIcon`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Icon URL'),
            group: `view:${uid}`,
            type: child.type,
            subType: _.get(child, 'props.control', 'text'),
            uid: id,
          })
        }
        if (_.get(child, 'props.control', 'text') == 'multiSelect') {
          rList.push({
            value: `${uid}:${id}:selectedCount`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Selected Count'),
            group: `view:${uid}`,
            type: child.type,
            subType: _.get(child, 'props.control', 'text'),
            uid: id,
          })
        }
        return rList
      } else if (
        _.get(child, 'props.control', 'text') === 'checkbox' &&
        _.get(child, 'props.source', 'single') === 'single' &&
        isRepeat
      ) {
        let labelPrefix = isRepeat ? `${repeatLabel} / ` : ''
        return [
          {
            value: `${valueStart}`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`),
            group: `view:${uid}`,
            type: child.type,
            subType: 'boolean',
            uid: id,
          },
          {
            value: `${uid}:${id}:selectedCount`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Selected Count'),
            group: `view:${uid}`,
            type: child.type,
            subType: 'number',
            uid: id,
          },
        ]
      } else if (
        _.get(child, 'props.control', 'text') === 'checkbox' &&
        _.get(child, 'props.source', 'single') !== 'single'
      ) {
        let labelPrefix = isRepeat ? `${repeatLabel} / ` : ''
        return [
          {
            value: `${valueStart}:ftListValue`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Value'),
            group: `view:${uid}`,
            uid: id,
          },
          {
            value: `${valueStart}:ftListLabel`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Label'),
            group: `view:${uid}`,
            uid: id,
          },
          {
            value: `${valueStart}:selectedCount`,
            label: labelPrefix + buildElementLabel(tag, `${prefix} / ${control}`, 'Selected Count '),
            group: `view:${uid}`,
            type: child.type,
            subType: 'number',
            uid: id,
          },
        ]
      } else if (_.get(child, 'props.control', 'text') === 'daterange') {
        push(
          `${valueStart}:startDate`,
          buildElementLabel(tag, `${prefix} / ${control}`, 'Start Date'),
          `view:${uid}`,
          'date'
        )
        push(
          `${valueStart}:endDate`,
          buildElementLabel(tag, `${prefix} / ${control}`, 'End Date'),
          `view:${uid}`,
          'date'
        )
        push(
          `${valueStart}-formattedValue`,
          buildElementLabel(tag, `${prefix} / ${control}`, 'Formatted Value'),
          `view:${uid}`,
          'string'
        )
      } else if (_.get(child, 'props.control', 'text') === 'currency') {
        push(`${valueStart}:value`, buildElementLabel(tag, `${prefix} / ${control}`, 'Value'))
        push(
          `${valueStart}:formattedValue`,
          buildElementLabel(tag, `${prefix} / ${control}`, 'Formatted Value'),
          `view:${uid}`,
          'string'
        )
      } else if (
        _.get(child, 'props.control', 'text') === 'signature' &&
        _.get(child, ['props', 'lg', 'isCompanyMode'], false)
      ) {
        push(`${valueStart}-companyName`, buildElementLabel(tag, `${prefix} / ${control}`, 'Company Name'))
        push(`${valueStart}-companyLabRegNum`, buildElementLabel(tag, `${prefix} / ${control}`, 'Label Reg number'))
        push(`${valueStart}-companyRegNum`, buildElementLabel(tag, `${prefix} / ${control}`, 'Company Reg Number'))
      } else if (_.get(child, 'props.control', 'text') === 'fileupload') {
        // push(`${valueStart}-ids`, buildElementLabel(tag, `${prefix} / ${control}`, 'File ID'))
        if (isInCondition) {
          push(`${valueStart}:ft_fileupload`, buildElementLabel(tag, `${prefix} / ${control}`, 'File'))
        } else {
          push(`${valueStart}`, buildElementLabel(tag, `${prefix} / ${control}`, 'File'))
        }
        push(`${valueStart}-filesID`, buildElementLabel(tag, `${prefix} / ${control}`, 'File Record ID'))
        push(`${valueStart}-files`, buildElementLabel(tag, `${prefix} / ${control}`, 'File Name'))
        push(`${valueStart}-url`, buildElementLabel(tag, `${prefix} / ${control}`, 'File URL'))
      } else {
        if (_.get(child, 'props.control', 'text') == 'slider') {
          push(`${valueStart}`, buildElementLabel(tag, `${prefix} / ${control}`), `view:${uid}`, 'number')
        } else {
          push(`${valueStart}`, buildElementLabel(tag, `${prefix} / ${control}`))
        }
        if (_.get(child, 'props.control', 'text') === 'text' && _.get(child, 'props.allowAutoSuggest', false)) {
          push(`${valueStart}-ft_search`, buildElementLabel(tag, `${prefix} / ${control}`, 'Search Text'))
        }
        if (['number', 'date', 'time', 'datetime'].includes(_.get(child, 'props.control', 'text'))) {
          push(
            `${valueStart}-formattedValue`,
            buildElementLabel(tag, `${prefix} / ${control}`, 'Formatted Value'),
            `view:${uid}`,
            'string'
          )
        }
      }
      break
    }
    case 'CircleSlider':
      push(`${valueStart}:value`, buildElementLabel(tag, getDisplayType(child.type), 'Value'))
      push(`${valueStart}:min`, buildElementLabel(tag, getDisplayType(child.type), 'Min Value'))
      push(`${valueStart}:max`, buildElementLabel(tag, getDisplayType(child.type), 'Max Value'))
      if (child?.props?.v2) {
        push(`${valueStart}:maxTrackValue`, buildElementLabel(tag, getDisplayType(child.type), 'Max Track Value'))
        push(`${valueStart}:prefix`, buildElementLabel(tag, getDisplayType(child.type), 'Prefix'))
        push(`${valueStart}:suffix`, buildElementLabel(tag, getDisplayType(child.type), 'Suffix'))
      } else {
        push(`${valueStart}:stepSize`, buildElementLabel(tag, getDisplayType(child.type), 'Step Size'))
      }
      break
    case 'TextCounter':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      break
    case 'Counter':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      push(`${valueStart}:VALUE`, buildElementLabel(tag, getDisplayType(child.type), 'Value'))
      if (_.get(child, 'props.mode', COUNTER_MODE_COUNT) === COUNTER_MODE_INTERVAL) {
        push(`${valueStart}:VALUE_STEP`, buildElementLabel(tag, getDisplayType(child.type), 'Value Step'))
      }
      break
    case 'Typography':
      push(`${valueStart}:TYPO_TEXT`, buildElementLabel(tag, 'Text'))
      break
    case 'Link':
      if (!isInCondition) {
        push(`${valueStart}`, buildElementLabel(tag, 'Link', 'HREF'))
        push(`${valueStart}-title`, buildElementLabel(tag, 'Link', 'Text'))
      }
      break
    case 'Range':
      return [
        {
          value: `${valueStart}:min`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Min'),
          group: `view:${uid}`,
          type: 'Range',
          subType: 'number',
          uid: id,
        },
        {
          value: `${valueStart}:max`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Max'),
          group: `view:${uid}`,
          type: 'Range',
          subType: 'number',
          uid: id,
        },
      ]
      break
    case 'SurveyList':
    case 'CES':
      return [
        {
          value: `${valueStart}:ftListValue`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Value'),
          group: `view:${uid}`,
          uid: id,
        },
        {
          value: `${valueStart}:ftListLabel`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Label'),
          group: `view:${uid}`,
          uid: id,
        },
      ]
      break
    case 'Ranking':
      if (_.get(child, ['props', 'source'], 'static') === 'sf') {
        push(`${valueStart}:index`, buildElementLabel(tag, getDisplayType(child.type), 'Item Index'))
        push(`${valueStart}:value`, buildElementLabel(tag, getDisplayType(child.type), 'Item Value'))
        push(`${valueStart}:label`, buildElementLabel(tag, getDisplayType(child.type), 'Item Label'))
      } else {
        _.map(_.get(child, ['props', 'items']), (row) => {
          push(`${valueStart}:${row.uid}`, buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Index'))
          push(
            `${valueStart}:${row.uid}-value`,
            buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Value')
          )
          push(
            `${valueStart}:${row.uid}-label`,
            buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Label')
          )
        })
      }
      break
    case 'Matrix':
      _.map(_.get(child, ['props', 'questions']), (row) => {
        push(`${valueStart}:${row.uid}`, buildElementLabel(tag, getDisplayType(child.type), row.label))
      })
      break
    case 'Rating':
    case 'StarRating':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)), null, 'number')
      break
    case 'YesNo':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)), null, 'boolean')
      break
    case 'Search':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      break
    case 'Progress':
      push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      break
    case 'FileViewer':
      if (!isInCondition) {
        push(`${valueStart}:url`, buildElementLabel(tag, getDisplayType(child.type), 'Content'))
        push(`${valueStart}:type`, buildElementLabel(tag, getDisplayType(child.type), 'Type'))
        push(`${valueStart}:name`, buildElementLabel(tag, getDisplayType(child.type), 'FileName'))
      }
      break
    case 'Vimeo':
      if (!isInCondition) {
        push(`${valueStart}`, buildElementLabel(tag, getDisplayType(child.type)))
      }
      break
    case 'Banner':
      if (!isInCondition) {
        push(`${valueStart}:IMG_ALT`, buildElementLabel(tag, getDisplayType(child.type), 'Alternative text'))
        push(`${valueStart}:IMG_TEXT`, buildElementLabel(tag, getDisplayType(child.type), 'Html Text'))
        push(`${valueStart}:IMG_SRC`, buildElementLabel(tag, getDisplayType(child.type), 'Source'))
        push(`${valueStart}:USER_TIP`, buildElementLabel(tag, getDisplayType(child.type), 'User Tip'))
      }
      break
    case 'Image':
      if (!isInCondition) {
        push(`${valueStart}:IMG_SRC`, buildElementLabel(tag, getDisplayType(child.type)))
        push(`${valueStart}:IMG_HOV_SRC`, buildElementLabel(tag, getDisplayType(child.type), 'Hover'))
        push(`${valueStart}:IMG_CLK_SRC`, buildElementLabel(tag, getDisplayType(child.type), 'OnClick'))
        push(`${valueStart}:USER_TIP`, buildElementLabel(tag, getDisplayType(child.type), 'User Tip'))
      }
      break
    case 'Button':
      if (!isInCondition) {
        push(`${valueStart}:BTN_TEXT`, buildElementLabel(tag, getDisplayType(child.type)))
      }
      break
    case 'PageConditionalForm': {
      let tabChild = []
      if (_.get(child, ['props', 'source'], 'static') === 'static') {
        _.each(_.get(child, 'props.lg.tabs', []), (tab) => {
          if (isInCondition && !tab.isFinish) {
            //no finish slides in condition
            tabChild = [
              ...tabChild,
              ..._.flatMap(tab.children, (childId) => {
                if (childId === id) {
                  return []
                }
                const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
                if (_.isArray(childElem.children)) {
                  childElem.children = filterRecursiveChildren(childElem.children, childId)
                }
                return getElementMappingData(
                  childElem,
                  childId,
                  uid,
                  page,
                  isRepeat,
                  repeatUID,
                  repeatLabel,
                  isInCondition,
                  [],
                  isSurvey,
                  `${tab.label || ''} / `,
                  activeStep
                )
              }),
            ]
          } else if (!isInCondition && !tab.isFinish) {
            tabChild = [
              ...tabChild,
              ..._.flatMap(tab.children, (childId) => {
                if (childId === id) {
                  return []
                }
                const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
                if (_.isArray(childElem.children)) {
                  childElem.children = filterRecursiveChildren(childElem.children, childId)
                }
                // if (['Form', 'Section', 'Stack', 'Scroll', 'Tab', 'Accordion', 'Stepper', 'MultiStepper', 'CarouselContainer', 'TwoSideSection',].includes(childElem.type)) {
                return getElementMappingData(
                  childElem,
                  childId,
                  uid,
                  page,
                  isRepeat,
                  repeatUID,
                  repeatLabel,
                  isInCondition,
                  [],
                  isSurvey,
                  `${tab.label || ''} / `,
                  activeStep
                )
                // } else {
                //     return []
                // }
              }),
            ]
          }
        })
      } else {
        let tab = _.first(_.get(child, 'props.lg.tabs', []))
        tabChild = [
          ...tabChild,
          ..._.flatMap(tab.children, (childId) => {
            if (childId === id) {
              return []
            }
            const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
            if (_.isArray(childElem.children)) {
              childElem.children = filterRecursiveChildren(childElem.children, childId)
            }
            return getElementMappingData(
              childElem,
              childId,
              uid,
              page,
              isRepeat,
              repeatUID,
              repeatLabel,
              isInCondition,
              [],
              isSurvey,
              `${tab.label || ''} / `,
              activeStep
            )
          }),
        ]
      }
      return [
        {
          value: `${valueStart}:ftListValue`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Value'),
          group: `view:${uid}`,
          uid: id,
        },
        {
          value: `${valueStart}:ftListLabel`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Label'),
          group: `view:${uid}`,
          uid: id,
        },
        ...tabChild,
      ]
    }
    case 'Tracker':
      return [
        {
          value: `${valueStart}:ftListValue`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Value'),
          group: `view:${uid}`,
          uid: id,
          type: child.type,
        },
        {
          value: `${valueStart}:ftListLabel`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Label'),
          group: `view:${uid}`,
          uid: id,
          type: child.type,
        },
      ]
    case 'ConditionalForm':
    case 'TwoSideSection':
    case 'CarouselContainer':
    case 'Accordion':
    case 'MultiStepper':
    case 'Stepper':
    case 'Tab':
      let tabChild = []
      if (_.get(child, ['props', 'source'], 'static') === 'static') {
        _.each(_.get(child, 'props.lg.tabs', []), (tab) => {
          tabChild = [
            ...tabChild,
            ..._.flatMap(tab.children, (childId) => {
              if (childId === id) {
                return []
              }
              const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
              if (_.isArray(childElem.children)) {
                childElem.children = filterRecursiveChildren(childElem.children, childId)
              }
              return getElementMappingData(
                childElem,
                childId,
                uid,
                page,
                isRepeat,
                repeatUID,
                repeatLabel,
                isInCondition,
                [],
                isSurvey,
                '',
                activeStep
              )
            }),
          ]
        })
      } else {
        let tab = _.first(_.get(child, 'props.lg.tabs', []))
        tabChild = [
          ...tabChild,
          ..._.flatMap(tab.children, (childId) => {
            if (childId === id) {
              return []
            }
            const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
            if (_.isArray(childElem.children)) {
              childElem.children = filterRecursiveChildren(childElem.children, childId)
            }
            return getElementMappingData(
              childElem,
              childId,
              uid,
              page,
              isRepeat,
              repeatUID,
              repeatLabel,
              isInCondition,
              [],
              isSurvey,
              '',
              activeStep
            )
          }),
        ]
      }
      return [
        ...(child.type === 'Stepper'
          ? [
              {
                value: `${valueStart}hover:ftListValue`,
                label: buildElementLabel(tag, getDisplayType(child.type), 'Hover Value'),
                group: `view:${uid}`,
                uid: id,
              },
              {
                value: `${valueStart}hover:ftListLabel`,
                label: buildElementLabel(tag, getDisplayType(child.type), 'Hover Label'),
                group: `view:${uid}`,
                uid: id,
              },
            ]
          : []),
        {
          value: `${valueStart}:ftListValue`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Value'),
          group: `view:${uid}`,
          uid: id,
          type: child.type,
        },
        {
          value: `${valueStart}:ftListLabel`,
          label: buildElementLabel(tag, getDisplayType(child.type), 'Label'),
          group: `view:${uid}`,
          uid: id,
          type: child.type,
        },
        ...(SKIP_IS_FIRST_LAST_TYPES.includes(child.type)
          ? []
          : [
              {
                value: `${valueStart}:ftIsFirst`,
                label: buildElementLabel(tag, getDisplayType(child.type), 'Is First'),
                group: `view:${uid}`,
                uid: id,
              },
              {
                value: `${valueStart}:ftIsLast`,
                label: buildElementLabel(tag, getDisplayType(child.type), 'Is Last'),
                group: `view:${uid}`,
                uid: id,
              },
            ]),
        ...tabChild,
      ]
      break
    case 'RepeatAutoFit': {
      const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      const paramType = `[Rep.AutoFit]`
      const repeatLabel = `${paramType}${tag ? ` ${tag}` : tag}`
      push(`${uid}:${id}:value`, buildElementLabel(tag, paramType, 'Value'))
      push(`${uid}:${id}:ftStripRow`, buildElementLabel(tag, paramType, 'Index'), `view:${uid}`, 'number')
      push(`${uid}:${id}-totalRows`, buildElementLabel(tag, paramType, 'Total Rows'), 'formWidget:' + id)
      _.each(filterEditableParametersJS(_.get(child, ['props', 'params'], [])), function (param) {
        push(`${uid}:${id}:${param.id}`, buildElementLabel(tag, paramType, param.name))
      })
      ret = [
        ...ret,
        ..._.flatMap(child.children, (childId) => {
          if (childId === id) {
            return []
          }
          const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
          if (_.isArray(childElem.children)) {
            childElem.children = filterRecursiveChildren(childElem.children, childId)
          }
          return getElementMappingData(
            childElem,
            childId,
            uid,
            page,
            true,
            id,
            repeatLabel,
            isInCondition,
            [],
            isSurvey,
            '',
            activeStep
          )
        }),
      ]
      break
    }
    case 'Badge':
      if (!isInCondition) {
        push(valueStart, buildElementLabel(tag, getDisplayType(child.type)))
      }
      break
    case 'Typography':
      if (!isInCondition) {
        push(`${valueStart}:TYPO_TEXT`, buildElementLabel(tag, getDisplayType(child.type)))
      }
      break
    case 'ItemList':
      if (!isInCondition) {
        push(`${valueStart}:text`, buildElementLabel(tag, getDisplayType(child.type), 'Label'))
        push(`${valueStart}:href`, buildElementLabel(tag, getDisplayType(child.type), 'URL'))
        push(`${valueStart}:target`, buildElementLabel(tag, getDisplayType(child.type), 'Target'))
      }
      break
    case 'Breadcrumb':
      if (!isInCondition) {
        push(`${valueStart}:text`, buildElementLabel(tag, getDisplayType(child.type), 'Label'))
        push(`${valueStart}:href`, buildElementLabel(tag, getDisplayType(child.type), 'URL'))
        push(`${valueStart}:target`, buildElementLabel(tag, getDisplayType(child.type), 'Target'))
      }
      break
    case 'PowerTable': {
      const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
      const tag = rawTag ? rawTag || '' : ''
      const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``

      push(`${valueStart}:value`, buildElementLabel(tag, `${subTag}PowerTable`, 'Value'), 'PowerTableWidget:' + id)
      push(
        `${valueStart}-selectedItems`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Selection'),
        'formWidget:' + id
      )
      push(
        `${valueStart}-selectedCount`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Selected Count '),
        'formWidget:' + id,
        'number'
      )

      push(
        `${valueStart}-PowerTableBatchChanged`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Batch Changed'),
        'formWidget:' + id
      )
      push(
        `${valueStart}-PowerTableBatchCompleted`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Batch Completed'),
        'formWidget:' + id
      )
      push(
        `${valueStart}-PowerTableBatchResult`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Batch Result Values'),
        'formWidget:' + id
      )
      push(
        `${valueStart}-PowerTableBatchSuccess`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Batch Success Values'),
        'formWidget:' + id
      )
      push(
        `${valueStart}-PowerTableBatchFailed`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Batch Failed Values'),
        'formWidget:' + id
      )

      push(`${valueStart}-totalRows`, buildElementLabel(tag, `${subTag}PowerTable`, 'Total Rows'), 'formWidget:' + id)
      push(
        `${valueStart}:selected`,
        buildElementLabel(tag, `${subTag}PowerTable`, 'Row Selection Status'),
        'PowerTableWidget:' + id
      )

      const processColumn = (col, colIndex) => {
        if (_.size(_.get(col, 'columns', [])) === 0) {
          if (_.get(col, ['meta', 'role']) === 'field') {
            let sfType = _.get(col, ['meta', 'field', 'type'])
            if (sfType === 'reference' && _.get(col, ['meta', 'allowEdit'])) {
              push(
                `${uid}:lookup-${id}:${col.id}:ft_search`,
                buildElementLabel(tag, `${subTag}PowerTable`, 'Search Text'),
                `lookup-${id}:${col.id}`,
                sfType
              )
            }
            let ftType = getSFFieldType(sfType)
            if (!['boolean', 'number', 'date', 'time', 'datetime'].includes(ftType)) {
              ftType = 'text'
            }
            push(
              `${valueStart}:${col.id}`,
              buildElementLabel(tag, `${subTag}PowerTable`, col.Header ?? ''),
              'PowerTableWidget:' + id,
              ftType
            )
          } else if (_.get(col, ['meta', 'role']) === 'input') {
            let sfType = _.get(col, ['meta', 'type'])
            let ftType = getSFFieldType(sfType)
            if (!['boolean', 'number', 'date', 'time', 'datetime'].includes(ftType)) {
              ftType = 'text'
            }
            push(
              `${valueStart}:${col.id}`,
              buildElementLabel(tag, `${subTag}PowerTable`, col.Header ?? ''),
              'PowerTableWidget:' + id,
              ftType
            )
          }
          if (!_.isEmpty(_.get(col, 'meta.subCtrl.Props', {}))) {
            let el = {}
            const subTag = Boolean(_.get(col, 'meta.subCtrl.Props.tag'))
              ? `[${col.Header || 'Col' + (colIndex + 1)}]${_.get(col, 'meta.subCtrl.Props.tag') || ''}`
              : `[${col.Header || 'Col' + (colIndex + 1)}]${tag}`

            if (_.get(col, 'meta.subCtrl.Type') === 'PowerTable') {
              el = {
                type: 'PowerTable',
                props: {
                  subTag,
                  ..._.get(col, 'meta.subCtrl.Props', {}),
                },
              }
            } else {
              el = {
                type: 'Widget',
                props: {
                  subTag,
                  data: _.get(col, 'meta.subCtrl', {}),
                },
              }
            }
            let elID = id
            if (String(id).indexOf('##') !== -1) {
              elID = _.first(String(id).split('##'))
            }

            ret = [
              ...ret,
              ...getElementMappingData(
                el,
                `${elID}##${col.id}`,
                uid,
                page,
                isRepeat,
                repeatUID,
                repeatLabel,
                isInCondition,
                [],
                isSurvey,
                '',
                activeStep
              ),
            ]
          }
        } else {
          _.each(_.get(col, 'columns', []), processColumn)
        }
      }

      _.each(_.get(child, 'props.columns', []), processColumn)
      break
    }
    case 'Widget':
      const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``
      switch (_.get(child, 'props.data.Type')) {
        case 'TablePricing': {
          push(`${valueStart}-selectedItems`, buildElementLabel(tag, `TablePricing`, 'Selected'))
          push(`${valueStart}-total`, buildElementLabel(tag, `TablePricing`, 'Total'))
          push(`${valueStart}-totalFormated`, buildElementLabel(tag, `TablePricing`, 'Total Formatted'))
          _.each(TablePricingFields, ({ key, label }) => {
            push(`${valueStart}:${key}`, buildElementLabel(tag, `TablePricing`, label))
          })
          break
        }
        case 'Scheduler':
          push(`${valueStart}:activeUserID`, buildElementLabel(tag, `Scheduler`, 'User'))
          push(`${valueStart}:activeUserAvatar`, buildElementLabel(tag, `Scheduler`, 'User Avatar'))
          push(`${valueStart}:activeUserName`, buildElementLabel(tag, `Scheduler`, 'User Name'))
          push(`${valueStart}:activeUserHeading`, buildElementLabel(tag, `Scheduler`, 'User Heading'))
          push(`${valueStart}:activeUserDescription`, buildElementLabel(tag, `Scheduler`, 'User Description'))
          push(`${valueStart}:activeUserFromTime`, buildElementLabel(tag, `Scheduler`, 'User From Time'))
          push(`${valueStart}:activeUserToTime`, buildElementLabel(tag, `Scheduler`, 'User To Time'))
          push(`${valueStart}:date`, buildElementLabel(tag, `Scheduler`, 'Date'))
          push(`${valueStart}:datetime`, buildElementLabel(tag, `Scheduler`, 'Date Time'))
          push(`${valueStart}:time`, buildElementLabel(tag, `Scheduler`, 'Time'))
          push(`${valueStart}:activeMID`, buildElementLabel(tag, `Scheduler`, 'Meeting Type ID'))
          push(`${valueStart}:duration`, buildElementLabel(tag, `Scheduler`, 'Meeting Duration'))
          push(`${valueStart}:endTime`, buildElementLabel(tag, `Scheduler`, 'End Time'))
          push(`${valueStart}:endDatetime`, buildElementLabel(tag, `Scheduler`, 'End DateTime'))
          _.each(_.get(child, 'props.data.Props.formMapping.mapping', []), (field) => {
            push(`${valueStart}:${field.id}`, buildElementLabel(tag, `Scheduler`, `Form / ${field.label}`))
          })
          const children = child.children
          if (_.isArray(children)) {
            _.flatMap(child.children, (childId) => {
              const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
              let items = getElementMappingData(
                childElem,
                childId,
                uid,
                page,
                isRepeat,
                repeatUID,
                repeatLabel,
                isInCondition,
                [],
                false,
                '',
                activeStep
              )
              _.each(items, (item) => {
                ret.push(item)
              })
            })
          }
          break
        case 'iframe':
          push(`${valueStart}`, buildElementLabel(tag, getDisplayType('Iframe'), 'SRC'))
          break
        case 'ImageChoice':
          push(`${valueStart}:ftListValue`, buildElementLabel(tag, getDisplayType('ImageChoice')))
          break
        case 'TreeView': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``

          push(`${valueStart}:value`, buildElementLabel(tag, `${subTag}TreeView`, 'Value'), 'PowerTableWidget:' + id)
          push(
            `${valueStart}-selectedItems`,
            buildElementLabel(tag, `${subTag}TreeView`, 'Selected'),
            'formWidget:' + id
          )
          push(`${valueStart}-totalRows`, buildElementLabel(tag, `${subTag}TreeView`, 'Total Rows'), 'formWidget:' + id)

          const processColumn = (col, colIndex) => {
            if (_.size(_.get(col, 'columns', [])) === 0) {
              if (_.get(col, ['meta', 'role']) === 'field') {
                push(
                  `${valueStart}:${col.id}`,
                  buildElementLabel(tag, `${subTag}TreeView`, col.Header ?? ''),
                  'PowerTableWidget:' + id,
                  getSalseForceFieldType(col.type)
                )
              }
              if (!_.isEmpty(_.get(col, 'meta.subCtrl.Props', {}))) {
                let el = {}
                const subTag = Boolean(_.get(col, 'meta.subCtrl.Props.tag'))
                  ? `[${col.Header || 'Col' + (colIndex + 1)}]${_.get(col, 'meta.subCtrl.Props.tag') || ''}`
                  : `[${col.Header || 'Col' + (colIndex + 1)}]${tag}`
                if (_.get(col, 'meta.subCtrl.Type') === 'PowerTable') {
                  el = {
                    type: 'PowerTable',
                    props: {
                      subTag,
                      ..._.get(col, 'meta.subCtrl.Props', {}),
                    },
                  }
                } else {
                  el = {
                    type: 'Widget',
                    props: {
                      subTag,
                      data: _.get(col, 'meta.subCtrl', {}),
                    },
                  }
                }
                let elID = id
                if (String(id).indexOf('##') !== -1) {
                  elID = _.first(String(id).split('##'))
                }

                ret = [
                  ...ret,
                  ...getElementMappingData(
                    el,
                    `${elID}##${col.id}`,
                    uid,
                    page,
                    isRepeat,
                    repeatUID,
                    repeatLabel,
                    isInCondition,
                    [],
                    isSurvey,
                    '',
                    activeStep
                  ),
                ]
              }
              if (_.get(col, ['meta', 'icon', 'field'])) {
                push(
                  `${valueStart}:${col.id}-icon`,
                  buildElementLabel(tag, `${subTag}TreeView`, (col.Header ?? '') + ' Icon'),
                  'PowerTableWidget:' + id
                )
              }
            } else {
              _.each(_.get(col, 'columns', []), processColumn)
            }
          }

          _.each(_.get(child, 'props.columns', []), processColumn)
          break
        }
        case 'table': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          if (_.get(child, 'props.data.Props.isAllowSelectRow', false)) {
            push(`${valueStart}-selectedItems`, buildElementLabel(tag, 'Table', 'Selection'), 'formWidget:' + id)
          }
          push(`${valueStart}-totalRows`, buildElementLabel(tag, 'Table', 'Total Rows'), 'formWidget:' + id)
          push(`${valueStart}:value`, buildElementLabel(tag, 'Table', 'Value'), 'tableWidget:' + id)
          _.each(_.get(child, 'props.data.Props.mapping', []), (field) => {
            push(
              `${valueStart}:${field.id}`,
              buildElementLabel(tag, `Table`, field.label),
              'tableWidget:' + id,
              getSalseForceFieldType(field.type)
            )
          })

          break
        }
        case 'infoBox': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          _.each(InfoBoxFields, function (field) {
            push(
              `${valueStart}:${field.key}`,
              buildElementLabel(tag, `${subTag}Tile`, field.label),
              'infoBoxWidget:' + id
            )
          })
          break
        }
        case 'Ticker': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          _.each(InfoBoxFields, function (field) {
            push(
              `${valueStart}:${field.key}`,
              buildElementLabel(tag, `${subTag}Tile`, field.label),
              'infoBoxWidget:' + id
            )
          })
          break
        }
        case 'chart': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          push(`${valueStart}-selected`, buildElementLabel(tag, `${subTag}Chart`, 'Selected'), 'formWidget:' + id)
          push(`${valueStart}:x`, buildElementLabel(tag, `${subTag}Chart`, 'X'), 'chartWidget:' + id)
          push(`${valueStart}:y`, buildElementLabel(tag, `${subTag}Chart`, 'Y'), 'chartWidget:' + id)

          if (_.get(child, 'props.data.Props.ChartType') === 'bubble') {
            push(`${valueStart}:r`, buildElementLabel(tag, `${subTag}Chart`, 'Radius'), 'chartWidget:' + id)
          }
          if (['pie', 'doughnut'].indexOf(_.get(child, 'props.data.Props.ChartType')) == -1) {
            push(`${valueStart}:label`, buildElementLabel(tag, `${subTag}Chart`, 'Label'), 'chartWidget:' + id)
          }
          if (['doughnut'].includes(_.get(child, 'props.data.Props.ChartType'))) {
            push(`${valueStart}-innerText`, buildElementLabel(tag, `${subTag}Chart`, 'Inner Text'))
          }
          _.each(_.get(child, 'props.data.Props.sfMapping.params', []), (param) => {
            push(
              `${valueStart}:${param.id}`,
              buildElementLabel(tag, `${subTag}Chart`, param.label),
              'chartWidget:' + id
            )
          })
          break
        }
        case 'Spreadsheet': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          push(`${valueStart}-totalRows`, buildElementLabel(tag, `Spreadsheet`, 'Total Rows'), 'view:' + id)
          push(`${valueStart}:value`, buildElementLabel(tag, `Spreadsheet`, 'Value'), 'view:' + id)
          _.map(_.get(child, 'props.data.Props.mapping', []), (field) => {
            push(
              `${valueStart}:${field.id}`,
              buildElementLabel(tag, `Spreadsheet`, field.label),
              'view:' + id,
              getSalseForceFieldType(field.type)
            )
          })
          break
        }
        case 'list': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          push(`${valueStart}-totalRows`, buildElementLabel(tag, `${subTag}List`, 'Total Rows'), 'formWidget:' + id)
          if (_.get(child, 'props.data.Props.isAllowSelectable', false)) {
            push(
              `${valueStart}:selectedItems`,
              buildElementLabel(tag, `${subTag}List`, 'Selection'),
              'formWidget:' + id
            )
            if (_.get(child, 'props.data.Props.isEnableGrouping', false)) {
              push(
                `${valueStart}:selectedGroupItems`,
                buildElementLabel(tag, `${subTag}List`, 'Group Selection'),
                'listWidget:' + id
              )
            }
          }
          if (_.get(child, 'props.data.Props.isEnableGrouping', false)) {
            push(`${valueStart}:groupText`, buildElementLabel(tag, `${subTag}List`, 'Group Text'), 'listWidget:' + id)
            push(`${valueStart}:groupValue`, buildElementLabel(tag, `${subTag}List`, 'Group Value'), 'listWidget:' + id)
            push(`${valueStart}:groupIcon`, buildElementLabel(tag, `${subTag}List`, 'Group Icon'), 'listWidget:' + id)
          }
          _.each(WidgetListFields, function (field) {
            push(`${valueStart}:${field.key}`, buildElementLabel(tag, `${subTag}List`, field.label), 'listWidget:' + id)
          })
          _.map(_.get(child, 'props.data.Props.columns', []), (field) => {
            push(
              `${valueStart}:${field.id}`,
              buildElementLabel(tag, `${subTag}List`, field.label),
              'listWidget:' + id,
              getSalseForceFieldType(field.type)
            )
          })
          break
        }
        case 'galleryCarousel': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          push(
            `${valueStart}:original`,
            buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Original'),
            'galleryCarouselWidget:' + id
          )
          push(
            `${valueStart}:originalAlt`,
            buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Original Alt'),
            'galleryCarouselWidget:' + id
          )
          push(
            `${valueStart}:originalTitle`,
            buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Original Title'),
            'galleryCarouselWidget:' + id
          )
          push(
            `${valueStart}:description`,
            buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Description'),
            'galleryCarouselWidget:' + id
          )

          if (_.get(child, 'props.data.Props.isShowFullscreenButton', true)) {
            push(
              `${valueStart}:fullscreen`,
              buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Fullscreen'),
              'galleryCarouselWidget: ' + id
            )
          }
          if (_.get(child, 'props.data.Props.isShowThumbnails', true)) {
            push(
              `${valueStart}:thumbnail`,
              buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Thumbnail'),
              'galleryCarouselWidget:' + id
            )
            push(
              `${valueStart}:thumbnailLabel`,
              buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Thumbnail Label'),
              'galleryCarouselWidget:' + id
            )
            push(
              `${valueStart}:thumbnailTitle`,
              buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Thumbnail Title'),
              'galleryCarouselWidget:' + id
            )
            push(
              `${valueStart}:thumbnailAlt`,
              buildElementLabel(tag, `${subTag}Gallery Carousel`, 'Thumbnail Alt'),
              'galleryCarouselWidget:' + id
            )
          }
          break
        }
        case 'galleryGrid': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''

          push(
            `${valueStart}:src`,
            buildElementLabel(tag, `${subTag}Gallery Grid`, 'Original'),
            'galleryGridWidget:' + id
          )
          push(
            `${valueStart}:thumbnail`,
            buildElementLabel(tag, `${subTag}Gallery Grid`, 'Thumbnail'),
            'galleryGridWidget:' + id
          )
          push(
            `${valueStart}:caption`,
            buildElementLabel(tag, `${subTag}Gallery Grid`, 'Caption'),
            'galleryGridWidget:' + id
          )

          break
        }
        case 'ExtendedGallery': {
          const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ``
          const tag = rawTag ? ` / ${rawTag || ''}` : ''
          _.each(ExtendedGalleryFields, function (row) {
            push(
              `${valueStart}:${row.key}`,
              buildElementLabel(tag, `${subTag}Extended Gallery`, row.label),
              'ExtendedGalleryWidget:' + id
            )
          })

          break
        }
      }
      break
    case 'Strip':
      push(`${uid}:${id}:value`, buildElementLabel(tag, `Strip`, 'Value'))
      push(`${uid}:${id}:ftStripRow`, buildElementLabel(tag, `Strip`, 'Index'), `view:${uid}`, 'number')
      push(`${uid}:${id}:ftSelVal`, buildElementLabel(tag, `Strip`, 'Selected Values'))
      push(`${uid}:${id}:ftIsSelVal`, buildElementLabel(tag, `Strip`, 'Is Selected'))
      if (child?.props?.isRepeat || child?.props?.isRepeatCol) {
        push(`${uid}:${id}-totalRows`, buildElementLabel(tag, `Strip`, 'Total Rows'), 'formWidget:' + id)
      }
      _.each(filterEditableParametersJS(_.get(child, ['props', 'params'], []), isInCondition), function (param) {
        push(`${uid}:${id}:${param.id}`, buildElementLabel(tag, `Strip`, param.name), `view:${uid}`, 'stripParam')
      })
      ret = [
        ...ret,
        ..._.flatMap(child.children, (childId) => {
          const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
          return getElementMappingData(
            childElem,
            childId,
            uid,
            page,
            isRepeat,
            repeatUID,
            repeatLabel,
            isInCondition,
            [],
            false,
            '',
            activeStep
          )
        }),
      ]
      break
    case 'DrawerEl':
    case 'Modal':
      if (child.type === 'Modal' && child.props?.isExp) {
        _.each(child?.props?.lg?.tabs, (tab) => {
          _.each(tab?.children, (childId) => {
            if (childId === id) {
              return []
            }
            const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
            if (_.isArray(childElem.children)) {
              childElem.children = _.filter(childElem.children, (child) => {
                if (_.isArray(child)) {
                  return _.filter(child, (v) => v !== childId)
                } else {
                  return child !== childId
                }
              })
            }
            ret = [
              ...ret,
              ...getElementMappingData(
                childElem,
                childId,
                id,
                page,
                isRepeat,
                repeatUID,
                repeatLabel,
                isInCondition,
                [],
                '',
                false,
                activeStep
              ),
            ]
          })
        })
      } else {
        let list = _.flatMap(_.flatten(child.children), (childId) => {
          if (childId === id) {
            return []
          }
          const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
          if (_.isArray(childElem.children)) {
            childElem.children = _.filter(childElem.children, (child) => {
              if (_.isArray(child)) {
                return _.filter(child, (v) => v !== childId)
              } else {
                return child !== childId
              }
            })
          }
          return getElementMappingData(
            childElem,
            childId,
            id,
            page,
            isRepeat,
            repeatUID,
            repeatLabel,
            isInCondition,
            [],
            '',
            false,
            activeStep
          )
        })
        ret = [...ret, ...list]
      }
      break
    case 'Kanban':
      push(`${valueStart}:value`, buildElementLabel(tag, `Kanban`, 'Value'))
      push(`${valueStart}:groupValue`, buildElementLabel(tag, `Kanban`, 'Group Value'))
      push(`${valueStart}:groupTitle`, buildElementLabel(tag, `Kanban`, 'Group Title'))
      push(`${valueStart}:title`, buildElementLabel(tag, `Kanban`, 'Title'))
      push(`${valueStart}:details`, buildElementLabel(tag, `Kanban`, 'Details'))
      break
    default:
      if (child.type === 'Form') {
        push(`${valueStart}-isChanged`, buildElementLabel(tag, getDisplayType(child.type), 'Is Changed'))
      }
      ret = [
        ...ret,
        ..._.flatMap(child.children, (childId) => {
          if (childId === id) {
            return []
          }
          const childElem = page.getIn(['Props', 'elements', childId], Map()).toJS()
          if (_.isArray(childElem.children)) {
            childElem.children = _.filter(childElem.children, (child) => {
              if (_.isArray(child)) {
                return _.filter(child, (v) => v !== childId)
              } else {
                return child !== childId
              }
            })
          }
          return getElementMappingData(
            childElem,
            childId,
            uid,
            page,
            isRepeat,
            repeatUID,
            repeatLabel,
            isInCondition,
            [],
            '',
            false,
            activeStep
          )
        }),
      ]
  }
  return ret
}

const getPageElements = (page, uid, isInCondition = false, isSurvey = false, activeStep) => {
  let rootElems = page.getIn(['Props', 'Grid'], List())
  let ret = []
  rootElems.map((id) => {
    const elem = page.getIn(['Props', 'elements', id], Map()).toJS()
    const isRepeat = _.get(elem, 'props.isRepeat', false)
    const isRepeatCol = _.get(elem, 'props.isRepeatCol', false)
    const tag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
    ret = [
      ...ret,
      ...getElementMappingData(
        elem,
        id,
        uid,
        page,
        isRepeat || isRepeatCol,
        id,
        `[Repeat${isRepeatCol ? ' Col' : ''}]${tag ? ` ${tag}` : tag}`,
        isInCondition,
        [],
        isSurvey,
        '',
        activeStep
      ),
    ]
  })
  return ret
}

const getPageExportElements = (page, uid, notInclude = []) => {
  let ret = []
  _.each(
    page
      .getIn(['Props', 'elements'], Map())
      .filter(
        (elem) =>
          !notInclude.includes(elem.get('type')) &&
          !notInclude.includes(elem.getIn(['props', 'control'])) &&
          !notInclude.includes(elem.getIn(['props', 'data', 'Type']))
      )
      .toJS(),
    (elem, id) => {
      const tag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
      let type = elem.type
      if (type === 'Widget') {
        type = _.get(elem, 'props.data.Type')
      }
      ret.push(option(`[${getDisplayType(type)}]${tag}`, id))
    }
  )
  return ret
}

const getElementPushMappingData = (
  child,
  id,
  uid,
  page,
  isRepeatParent,
  parentUID,
  repeatLabel = '',
  extra = { typo: false }
) => {
  if (String(id).indexOf('fit_') > -1) {
    return []
  }
  switch (child.type) {
    case 'TablePricing':
    case 'Scheduler':
    case 'ImageChoice':
    case 'table':
    case 'list':
    case 'Spreadsheet':
    case 'PowerTable':
    case 'CircleSlider':
    case 'CES':
    case 'SurveyList':
    case 'Range':
    case 'Ranking':
    case 'Matrix':
    case 'Rating':
    case 'StarRating':
    case 'YesNo':
    case 'DateRange':
    case 'GoogleMap':
    case 'FormField':
    case 'Kanban':
      uid = uid === 'project' ? _.get(child, 'parent', uid) : uid
      break
  }
  const _buildElementLabel = (...rest) =>
    isRepeatParent ? `${repeatLabel} / ${buildElementLabel(...rest)}` : buildElementLabel(...rest)
  if (child.type === 'Strip') {
    let stripParams = []
    const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    const isRepeat = _.get(child, 'props.isRepeat', false)
    const isRepeatCol = _.get(child, 'props.isRepeatCol', false)
    const repeatLabel = `[Repeat${isRepeatCol ? ' Col' : ''}]${tag ? ` ${tag}` : tag}`
    if (isRepeat || isRepeatCol) {
      const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      const tag = rawTag ? ` ${rawTag}` : ''
      stripParams.push({
        value: `${uid}:${id}:value`,
        label: _buildElementLabel(tag, repeatLabel, 'Value'),
        group: `view:${uid}`,
      })
      stripParams.push({
        value: `${uid}:${id}:ftStripRow`,
        label: _buildElementLabel(tag, repeatLabel, 'Index'),
        group: `view:${uid}`,
      })
      _.each(_.get(child, ['props', 'params'], []), function (param) {
        stripParams.push({
          value: `${uid}:${id}:${param.id}`,
          label: _buildElementLabel(tag, repeatLabel, param.name),
          group: `view:${uid}`,
        })
      })
    }
    let childList = _.uniq(child.children)
    return [
      ...stripParams,
      ..._.flatMap(childList, (childID) => {
        const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
        return getElementPushMappingData(elem, childID, uid, page, isRepeat || isRepeatCol, id, repeatLabel, extra)
      }),
    ]
  } else if (child.type === 'Typography' && extra?.typo) {
    const rawTag = _.get(child, 'props.tag', '') ? _.get(child, 'props.tag', '') : ''
    let tag = ''
    if (rawTag) {
      tag = `${rawTag}`
    } else if (_.get(child, 'props.lg.text', '')) {
      if (_.get(child, 'type') == 'Typography' && _.get(child, 'props.lg.isHTML')) {
        tag = ''
      } else {
        tag = `${_.get(child, 'props.lg.text', '')}`
      }
    }
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:TYPO_TEXT`,
        label: _buildElementLabel(tag, 'Typography'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'Widget') {
    let result = []
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    const tag = rawTag ? ` ${rawTag}` : ''
    switch (_.get(child, 'props.data.Type')) {
      case 'TablePricing': {
        const control = _.capitalize(getDisplayType('TablePricing'))
        let postFix = ''
        if (isRepeatParent) {
          postFix = `:${parentUID}`
        }
        let value = `${uid}${postFix}:${id}`
        return [
          {
            value: `${value}-selectedItems`,
            label: _buildElementLabel(tag, control, 'Selected'),
            group: `view:${uid}`,
          },
          {
            value: `${value}-total`,
            label: _buildElementLabel(tag, control, 'Total'),
            group: `view:${uid}`,
          },
          {
            value: `${value}-totalFormated`,
            label: _buildElementLabel(tag, control, 'Total Formatted'),
            group: `view:${uid}`,
          },
          ..._.map(TablePricingFields, ({ key, label }) => ({
            value: `${value}:${key}`,
            label: _buildElementLabel(tag, control, label),
            group: `view:${uid}`,
          })),
        ]
      }
      case 'Scheduler': {
        const control = _.capitalize(getDisplayType('Scheduler'))
        let postFix = ''
        if (isRepeatParent) {
          postFix = `:${parentUID}`
        }
        let value = `${uid}${postFix}:${id}`
        const fields = [
          ['activeUserAvatar', 'User Avatar'],
          ['activeUserName', 'User Name'],
          ['activeUserHeading', 'User Heading'],
          ['activeUserDescription', 'User Description'],
          ['activeUserFromTime', 'User From Time'],
          ['activeUserToTime', 'User To Time'],
        ]
        let childList = _.uniq(child.children)
        return [
          {
            value: `${value}:activeUserID`,
            label: _buildElementLabel(tag, control, 'User'),
            group: `view:${uid}`,
          },
          ..._.map(fields, ([key, label]) => ({
            value: `${value}:${key}`,
            label: _buildElementLabel(tag, control, label),
            group: `view:${uid}`,
          })),
          {
            value: `${value}:datetime`,
            label: _buildElementLabel(tag, control, 'DateTime'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:date`,
            label: _buildElementLabel(tag, control, 'Date'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:time`,
            label: _buildElementLabel(tag, control, 'Time'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:activeMID`,
            label: _buildElementLabel(tag, control, 'Meeting Type ID'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:duration`,
            label: _buildElementLabel(tag, control, 'Meeting Duration'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:endTime`,
            label: _buildElementLabel(tag, control, 'End Time'),
            group: `view:${uid}`,
          },
          {
            value: `${value}:endDatetime`,
            label: _buildElementLabel(tag, control, 'End DateTime'),
            group: `view:${uid}`,
          },
          ..._.map(_.get(child, 'props.data.Props.formMapping.mapping', []), (field) => {
            return {
              value: `${value}:${field.id}`,
              label: _buildElementLabel(tag, control, `Form / ${field.label}`),
              group: `view:${uid}`,
            }
          }),
          ..._.flatMap(childList, (childID) => {
            if (childID === id) {
              return []
            }
            const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
            if (_.isArray(elem.children)) {
              elem.children = _.filter(elem.children, (child) => {
                if (_.isArray(child)) {
                  return _.filter(child, (id) => id !== childID)
                } else {
                  return child !== childID
                }
              })
            }
            return getElementPushMappingData(elem, childID, uid, page, isRepeatParent, parentUID, repeatLabel, extra)
          }),
        ]
      }
      case 'ImageChoice':
        result.push({
          value: `${uid}:${id}:ftListValue`,
          label: _buildElementLabel(tag, `ImageChoice`, 'Selection'),
          group: `ImageChoice:${uid}`,
        })
        break
      case 'table': {
        result.push({
          value: `${uid}:${id}-selectedItems`,
          label: _buildElementLabel(tag, `Table`, 'Selection'),
          group: `WidgetTable:${uid}`,
        })
        break
      }
      case 'list': {
        result.push({
          value: `${uid}:${id}:selectedItems`,
          label: _buildElementLabel(tag, `List`, 'Selection'),
          group: `WidgetList:${uid}`,
        })
        break
      }
      case 'Spreadsheet': {
        let postFix = ''
        if (isRepeatParent) {
          postFix = `:${parentUID}`
        }
        let value = `${uid}${postFix}:${id}`
        result.push({
          value: `${value}:value`,
          label: _buildElementLabel(tag, `Spreadsheet`, 'Value'),
          group: `view:${uid}`,
        })
        _.map(_.get(child, 'props.data.Props.mapping', []), (field) => {
          result.push({
            value: `${value}:${field.id}`,
            label: _buildElementLabel(tag, `Spreadsheet`, field.label),
            group: `view:${uid}`,
          })
        })
        break
      }
    }
    return result
  } else if (child.type === 'InteractiveImage') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }

    return [
      {
        value: `${uid}${postFix}:${id}:value`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Mark Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:label`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Mark Label'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:top`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Mark Top Position'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:left`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Mark Left Position'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-size`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Total Marks'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-imgBase64`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Image Base64'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-imgHtml`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Image HTML'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-file`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Image File'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-fileWithMark`,
        label: _buildElementLabel(tag, 'InteractiveImage', 'Image File With Marks'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'BarcodeReader') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:text`,
        label: _buildElementLabel(tag, 'BarcodeReader', 'Button Text'),
        group: `view:${uid}`,
      },
      // {
      //     value: `${uid}${postFix}:${id}:status`,
      //     label: _buildElementLabel(tag, 'BarcodeReader', 'Scan Status'),
      //     group: `view:${uid}`
      // },
      {
        value: `${uid}${postFix}:${id}:valueType`,
        label: _buildElementLabel(tag, 'BarcodeReader', 'Value Type'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:value`,
        label: _buildElementLabel(tag, 'BarcodeReader', 'Value'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'ExternalLookup') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:search`,
        label: _buildElementLabel(tag, 'ExternalLookup', 'Search'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:value`,
        label: _buildElementLabel(tag, 'ExternalLookup', 'Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:label`,
        label: _buildElementLabel(tag, 'ExternalLookup', 'Label'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'YouTube') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}-status`,
        label: _buildElementLabel(tag, 'YouTube', 'Status'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}-time`,
        label: _buildElementLabel(tag, 'YouTube', 'Time'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'PowerTable') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }

    let ret = []
    ret.push({
      value: `${uid}:${id}-selectedItems`,
      label: _buildElementLabel(tag, `${subTag}PowerTable`, 'Selection'),
      group: `PowerTableWidget:${uid}`,
    })
    ret.push({
      value: `${uid}:${id}:selected`,
      label: _buildElementLabel(tag, `${subTag}PowerTable`, 'Row Selection Status'),
      group: `PowerTableWidget:${uid}`,
    })
    ret.push({
      value: `${uid}:${id}:value`,
      label: _buildElementLabel(tag, `${subTag}PowerTable`, 'Value'),
      group: `PowerTableWidget:${uid}`,
    })
    const processColumn = (col, colIndex) => {
      if (_.size(_.get(col, 'columns', [])) === 0) {
        ret.push({
          value: `${uid}:${id}:${col.id}`,
          label: _buildElementLabel(
            tag ? `${subTag || tag} / ${col.Header || 'Col'}` : '',
            `${subTag}PowerTable / ${col.Header || 'Col'}`
          ),
          group: `PowerTableWidget:${uid}`,
        })
        if (!_.isEmpty(_.get(col, 'meta.subCtrl.Props', {}))) {
          let el = {}
          const subTag = `[${col.Header || 'Col' + (colIndex + 1)}]${tag}`
          if (_.get(col, 'meta.subCtrl.Type') === 'PowerTable') {
            el = {
              type: 'PowerTable',
              props: {
                subTag,
                ..._.get(col, 'meta.subCtrl.Props', {}),
              },
            }
          } else {
            el = {
              type: 'Widget',
              props: {
                subTag,
                data: _.get(col, 'meta.subCtrl', {}),
              },
            }
          }
          let elID = id
          if (String(id).indexOf('##') !== -1) {
            elID = _.first(String(id).split('##'))
          }
          ret = [
            ...ret,
            ...getElementPushMappingData(
              el,
              `${id}##${col.id}`,
              uid,
              page,
              isRepeatParent,
              parentUID,
              repeatLabel,
              extra
            ),
          ]
        }
      } else {
        _.each(_.get(col, 'columns', []), processColumn)
      }
    }

    _.each(child?.props?.columns, processColumn)

    return ret
  } else if (['CircleSlider'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:value`,
        label: _buildElementLabel(tag, control, 'Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:min`,
        label: _buildElementLabel(tag, control, 'Min Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:max`,
        label: _buildElementLabel(tag, control, 'Max Value'),
        group: `view:${uid}`,
      },
      ...(child?.props?.v2
        ? [
            {
              value: `${uid}${postFix}:${id}:maxTrackValue`,
              label: _buildElementLabel(tag, control, 'Max Track Value'),
              group: `view:${uid}`,
            },
            {
              value: `${uid}${postFix}:${id}:prefix`,
              label: _buildElementLabel(tag, control, 'Prefix'),
              group: `view:${uid}`,
            },
            {
              value: `${uid}${postFix}:${id}:suffix`,
              label: _buildElementLabel(tag, control, 'Suffix'),
              group: `view:${uid}`,
            },
          ]
        : [
            {
              value: `${uid}${postFix}:${id}:stepSize`,
              label: _buildElementLabel(tag, control, 'Step Size'),
              group: `view:${uid}`,
            },
          ]),
    ]
  } else if (['CES', 'SurveyList'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:ftListValue`,
        label: _buildElementLabel(tag, control, 'Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:ftListLabel`,
        label: _buildElementLabel(tag, control, 'Label'),
        group: `view:${uid}`,
      },
    ]
  } else if (['Range'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:min`,
        label: _buildElementLabel(tag, control, 'Min'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:max`,
        label: _buildElementLabel(tag, control, 'Max'),
        group: `view:${uid}`,
      },
    ]
  } else if (['GoogleMap'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:selLat`,
        label: _buildElementLabel(tag, control, 'Selected Latitude'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:selLng`,
        label: _buildElementLabel(tag, control, 'Selected Longitude'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:selValue`,
        label: _buildElementLabel(tag, control, 'Selected Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:selText`,
        label: _buildElementLabel(tag, control, 'Selected Text'),
        group: `view:${uid}`,
      },
    ]
  } else if (['Ranking'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    let resultList = []
    let value = `${uid}${postFix}:${id}`
    if (_.get(child, ['props', 'source'], 'static') === 'sf') {
      return [
        {
          value: `${value}:index`,
          label: _buildElementLabel(tag, control, 'Index'),
          group: `view:${uid}`,
        },
        {
          value: `${value}:value`,
          label: _buildElementLabel(tag, control, 'Value'),
          group: `view:${uid}`,
        },
        {
          value: `${value}:label`,
          label: _buildElementLabel(tag, control, 'Label'),
          group: `view:${uid}`,
        },
      ]
    } else {
      let keyItems = 'items'
      _.map(_.get(child, ['props', keyItems]), (row) => {
        resultList.push({
          value: `${value}:${row.uid}`,
          label: _buildElementLabel(tag, control, row.label),
          group: `view:${uid}`,
        })
      })
    }
    return resultList
  } else if (['Matrix'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    let resultList = []
    let value = `${uid}${postFix}:${id}`
    let keyItems = 'items'
    if (child.type == 'Matrix') {
      keyItems = 'questions'
    }
    _.map(_.get(child, ['props', keyItems]), (row) => {
      resultList.push({
        value: `${value}:${row.uid}`,
        label: _buildElementLabel(tag, control, row.label),
        group: `view:${uid}`,
      })
    })
    return resultList
  } else if (['Rating', 'StarRating', 'YesNo', 'TextCounter'].indexOf(child.type) > -1) {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    let value = `${uid}${postFix}:${id}`
    return [
      {
        value: value,
        label: _buildElementLabel(tag, control),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'DateRange') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    let value = `${uid}${postFix}:${id}`
    return [
      {
        value: `${value}:startDate`,
        label: _buildElementLabel(tag, 'DateRange') + ' / Start Date',
        group: `view:${uid}`,
      },
      {
        value: `${value}:endDate`,
        label: _buildElementLabel(tag, 'DateRange') + ' / End Date',
        group: `view:${uid}`,
      },
      {
        value: `${value}-formattedValue`,
        label: _buildElementLabel(tag, 'DateRange') + ' / Formatted Value',
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'DiffViewer') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:left`,
        label: _buildElementLabel(tag, getDisplayType(child.type), ` Old`),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:right`,
        label: _buildElementLabel(tag, getDisplayType(child.type), ` New`),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'TextReview') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''

    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }

    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }

    return [
      {
        value: `${uid}${postFix}:${id}:old`,
        label: _buildElementLabel(tag, getDisplayType(child.type), 'Old'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:new`,
        label: _buildElementLabel(tag, getDisplayType(child.type), 'New'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:draft`,
        label: _buildElementLabel(tag, getDisplayType(child.type), 'Draft'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:value`,
        label: _buildElementLabel(tag, getDisplayType(child.type), 'Value'),
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:changesNumber`,
        label: _buildElementLabel(tag, getDisplayType(child.type), 'Number of Changes'),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'Capture') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(_.get(child, 'props.control', 'text')))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:ft_fileupload`,
        type: 'Capture',
        label: _buildElementLabel(tag, `Capture / ${control}`),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'InteractiveDocument') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(child.type))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}:ft_fileupload_docx`,
        type: 'InteractiveDocument',
        label: _buildElementLabel(tag, control) + '.docx',
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:ft_fileupload_sfdt`,
        type: 'InteractiveDocument',
        label: _buildElementLabel(tag, control) + '.sfdt',
        group: `view:${uid}`,
      },
      {
        value: `${uid}${postFix}:${id}:ft_fileupload_pdf`,
        type: 'InteractiveDocument',
        label: _buildElementLabel(tag, control) + '.pdf',
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'Search') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    return [
      {
        value: `${uid}${postFix}:${id}`,
        label: _buildElementLabel(tag, getDisplayType(child.type) + ` (${id})`),
        group: `view:${uid}`,
      },
    ]
  } else if (child.type === 'FormField') {
    const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    let tag = rawTag ? ` ${rawTag}` : ''
    if (!tag && _.get(child, 'props.lg.label', '')) {
      tag = `${_.get(child, 'props.lg.label', '')}`
    }
    const control = _.capitalize(getDisplayType(_.get(child, 'props.control', 'text')))
    let postFix = ''
    if (isRepeatParent) {
      postFix = `:${parentUID}`
    }
    if (_.get(child, 'props.control', 'text') === 'daterange') {
      return [
        {
          value: `${uid}${postFix}:${id}:startDate`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Start Date'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:endDate`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'End Date'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}-formattedValue`,
          label: _buildElementLabel(tag, 'FormField') + ' / Formatted Value',
          group: `view:${uid}`,
        },
      ]
    } else if (_.get(child, 'props.control', 'text') === 'currency') {
      return [
        {
          value: `${uid}${postFix}:${id}:value`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Value'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:formattedValue`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Formatted Value'),
          group: `view:${uid}`,
        },
      ]
    } else if (_.get(child, 'props.control', 'text') === 'fileupload') {
      return [
        {
          value: `${uid}${postFix}:${id}:ft_fileupload`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'File'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:ft_fileupload_html`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'As HTML'),
          group: `view:${uid}`,
        },
      ]
    } else if (_.get(child, 'props.control', 'text') === 'signature') {
      let isCompanyMode = _.get(child, 'props.lg.isCompanyMode')
      return [
        {
          value: `${uid}${postFix}:${id}:signature_base64`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`),
          group: `view:${uid}`,
        },
        // {
        //     value: `${valueStart}:signature_base30`,
        //     label: `[FormField / ${control} / Base30]${tag}`,
        //     group: `view:${uid}`
        // },
        {
          value: `${uid}${postFix}:${id}:signature_html`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'HTML'),
          group: `view:${uid}`,
        },
        ...(isCompanyMode
          ? [
              {
                value: `${uid}${postFix}:${id}-signature_company_base64`,
                type: 'FormField',
                label: _buildElementLabel(tag, `FormField / ${control}`, 'Company'),
                group: `view:${uid}`,
              },
              {
                value: `${uid}${postFix}:${id}-signature_company_html`,
                type: 'FormField',
                label: _buildElementLabel(tag, `FormField / ${control}`, 'Company HTML'),
                group: `view:${uid}`,
              },
            ]
          : []),
      ]
    } else if (_.get(child, 'props.control', 'text') === 'lookup') {
      return [
        {
          value: `${uid}${postFix}:${id}:ft_value`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Value'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:ft_text`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Text'),
          group: `view:${uid}`,
        },
      ]
    } else if (
      _.get(child, 'props.control', 'text') === 'checkbox' &&
      _.get(child, 'props.source', 'single') !== 'single'
    ) {
      return [
        {
          value: `${uid}${postFix}:${id}:ftListValue`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Value'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:ftListLabel`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Label'),
          group: `view:${uid}`,
        },
      ]
    } else if (LIST_BASED_FIELDS.indexOf(_.get(child, 'props.control', 'text')) > -1) {
      let rList = [
        {
          value: `${uid}${postFix}:${id}:ftListValue`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Value'),
          group: `view:${uid}`,
        },
        {
          value: `${uid}${postFix}:${id}:ftListLabel`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Label'),
          group: `view:${uid}`,
        },
      ]
      if (_.get(child, 'props.control', 'text')) {
        rList.push({
          value: `${uid}${postFix}:${id}:selectedCount`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`, 'Selected Count'),
          group: `view:${uid}`,
        })
      }
      return rList
    } else {
      return [
        {
          value: `${uid}${postFix}:${id}`,
          type: 'FormField',
          label: _buildElementLabel(tag, `FormField / ${control}`),
          group: `view:${uid}`,
        },
        ...(_.get(child, 'props.control', 'text') === 'text' && _.get(child, 'props.allowAutoSuggest', false)
          ? [
              {
                value: `${uid}${postFix}:${id}-ft_search`,
                type: 'FormField',
                label: _buildElementLabel(tag, `FormField / ${control}`, 'Search Text'),
                group: `view:${uid}`,
              },
            ]
          : []),
        ...(['number', 'date', 'time', 'datetime'].includes(_.get(child, 'props.control', 'text'))
          ? [
              {
                value: `${uid}${postFix}:${id}-formattedValue`,
                label: _buildElementLabel(tag, 'FormField') + ' / Formatted Value',
                group: `view:${uid}`,
              },
            ]
          : []),
      ]
    }
  } else if (child.type === 'RepeatAutoFit') {
    const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
    const repeatLabel = `[Rep.AutoFit]${tag ? ` ${tag}` : tag}`
    let params = []
    params.push({
      value: `${uid}:${id}:value`,
      label: _buildElementLabel(tag, repeatLabel, 'Value'),
      group: `view:${uid}`,
    })
    params.push({
      value: `${uid}:${id}:ftStripRow`,
      label: _buildElementLabel(tag, repeatLabel, 'Index'),
      group: `view:${uid}`,
    })
    _.each(_.get(child, ['props', 'params'], []), function (param) {
      params.push({
        value: `${uid}:${id}:${param.id}`,
        label: _buildElementLabel(tag, repeatLabel, param.name),
        group: `view:${uid}`,
      })
    })

    return [
      ...params,
      ..._.flatMap(child.children, (childID) => {
        const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
        if (_.isArray(elem.children)) {
          elem.children = _.filter(elem.children, (child) => {
            if (_.isArray(child)) {
              return _.filter(child, (id) => id !== childID)
            } else {
              return child !== childID
            }
          })
        }
        return getElementPushMappingData(elem, childID, uid, page, true, id, repeatLabel, extra)
      }),
    ]
  } else if (child.type === 'Modal' || child.type === 'DrawerEl') {
    if (child.type === 'Modal' && child.props?.isExp) {
      let elements = []
      _.each(child.props?.lg?.tabs, (tab) => {
        _.each(tab.children, (childID) => {
          const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
          if (_.isArray(elem.children)) {
            elem.children = _.filter(elem.children, (child) => {
              if (_.isArray(child)) {
                return _.filter(child, (id) => id !== childID)
              } else {
                return child !== childID
              }
            })
          }
          elements = [
            ...elements,
            ...getElementPushMappingData(elem, childID, id, page, isRepeatParent, parentUID, repeatLabel, extra),
          ]
        })
      })
      return elements
    } else {
      return [
        ..._.flatMap(_.flatten(child.children), (childID) => {
          const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
          if (_.isArray(elem.children)) {
            elem.children = _.filter(elem.children, (child) => {
              if (_.isArray(child)) {
                return _.filter(child, (id) => id !== childID)
              } else {
                return child !== childID
              }
            })
          }
          return getElementPushMappingData(elem, childID, id, page, isRepeatParent, parentUID, repeatLabel, extra)
        }),
      ]
    }
  } else if (_.size(child.children) > 0) {
    let childList = _.uniq(child.children)
    return [
      ..._.flatMap(childList, (childID) => {
        if (childID === id) {
          return []
        }
        const elem = page.getIn(['Props', 'elements', childID], Map()).toJS()
        if (_.isArray(elem.children)) {
          elem.children = _.filter(elem.children, (child) => {
            if (_.isArray(child)) {
              return _.filter(child, (id) => id !== childID)
            } else {
              return child !== childID
            }
          })
        }
        return getElementPushMappingData(elem, childID, uid, page, isRepeatParent, parentUID, repeatLabel, extra)
      }),
    ]
  }
  return []
}

export const getAllProjectParameters = (state) => {
  let ret = []
  state.getIn(['project', 'Settings', 'params'], List()).map((param) => {
    ret.push({
      value: param.get('id'),
      label: `[Project Val / ${param.get('name')}]`,
      group: 'param',
    })
  })

  state.getIn(['pages'], Map()).map((page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage) {
      page.getIn(['Props', 'params'], List()).map((param) => {
        ret.push({
          value: `${projectPage.get('uid')}:${param.get('id')}`,
          label: `[Page Val / ${projectPage.get('name', 'NoName')} / ${param.get('name')}]`,
          group: 'pageParam',
        })
      })
    }
  })

  return ret
}

let prevPush = null
let prevExtra = null
let resultsPush = null
export const getProjectMappingPushElems = (state, extra = { typo: false }) => {
  if (prevPush === null || resultsPush === null || Date.now() - prevPush > 1000 || !isSame(prevExtra, extra)) {
    prevPush = Date.now()
    prevExtra = extra
    resultsPush = _getProjectMappingPushElems(state, extra)
  }
  return resultsPush
}

export const _getProjectMappingPushElems = (state, extra = { typo: false }) => {
  let ret = state
    .getIn(['project', 'Settings', 'params'], List())
    .concat(state.getIn(['project', 'params'], List()))
    .map((param) => ({
      value: param.get('id'),
      label: `[GV / ${param.get('name')}]`,
      group: 'param',
    }))
    .toJS()

  if (!state.getIn(['project', 'isPublic'], true)) {
    ret.push({
      value: 'ftSessLeftTime',
      label: 'SmartV Session Time',
      group: 'param',
    })
  }

  if (state.getIn(['project', 'ProjectType'], 'web') == 'surveyEmail') {
    ret.push({
      value: `surveyValue`,
      label: `Value`,
      group: 'param',
    })
  }
  if (state.getIn(['project', 'Settings', 'ui', 'allowPushNotify'], false)) {
    ret.push({
      value: `pushNotifyHash`,
      label: `ft_webPush`,
      group: 'param',
    })
  }

  let calEvents = state
    .getIn(['project', 'Settings', 'store', 'private'], Map())
    .filter((setting) => setting.get('type') === CALENDAR_EVENT_TYPE)
  if (calEvents.size > 0) {
    calEvents.map((event) => {
      ret.push({
        value: event.get('id'),
        label: `[Calendar] / ${event.getIn(['title', 'textValue'], 'Event')}`,
        group: 'calendar',
      })
    })
  }

  let smartv = []
  if (
    state.getIn(['project', 'Settings', 'SmartV', 'useRegister'], false) &&
    state.getIn(['project', 'Settings', 'SmartV', 'useCustomRegister'], false)
  ) {
    state.getIn(['project', 'Settings', 'SmartV', 'regConfig'], List()).map((elem) => {
      smartv.push({
        value: `${elem.get('uid')}`,
        label: `[SmartV / ${elem.get('label')}]`,
        group: 'smartvReg',
      })
    })
    if (state.getIn(['project', 'Settings', 'SmartV', 'isUseGoogle'], false)) {
      const field = state
        .getIn(['project', 'Settings', 'SmartV', 'config'], List())
        .find((row) => row.get('mapType') === 'googleIDField')
      if (field) {
        smartv.push({
          value: `${field.get('uid')}`,
          label: `[SmartV / ${field.get('label')}]`,
          group: 'smartvReg',
        })
      }
    }
  }
  if (
    state.getIn(['project', 'Settings', 'SmartV', 'useProfile'], false) &&
    state.getIn(['project', 'Settings', 'SmartV', 'useCustomProfile'], false)
  ) {
    state.getIn(['project', 'Settings', 'SmartV', 'profile'], List()).map((elem) => {
      smartv.push({
        value: `SmartVProfile:${elem.get('field')}`,
        label: `[SmartV Profile / ${elem.get('label')}]`,
        group: 'SmartVProfile',
      })
    })
  }
  ret = _.concat(ret, smartv)

  const proessCustomElem = (uid) => {
    const elem = state.getIn(['project', 'Settings', 'elements', uid], Map()).toJS()
    let fakePage = fromJS({
      Props: {
        elements: state.getIn(['project', 'Settings', 'elements'], Map()),
      },
    })
    ret = [...ret, ...getElementPushMappingData(elem, uid, 'project', fakePage, undefined, undefined, undefined, extra)]
  }
  state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(proessCustomElem)
  state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(proessCustomElem)

  if (
    state.getIn(['project', 'Settings', 'Header', 'enable'], false) ||
    state.getIn(['project', 'ProjectType']) == 'chatBot'
  ) {
    try {
      const rootElems = state
        .getIn(['project', 'Settings', 'elements'], Map())
        .filter((elem) => elem.get('parent') === 'Header')
        .reduce((r, v, k) => [...r, k], [])

      const page = fromJS({
        Props: {
          elements: state.getIn(['project', 'Settings', 'elements'], Map()),
        },
      })

      rootElems.map((id) => {
        const elem = state.getIn(['project', 'Settings', 'elements', id], Map()).toJS()
        ret = [...ret, ...getElementPushMappingData(elem, id, 'Header', page, undefined, undefined, undefined, extra)]
      })
    } catch (error) {
      console.error(error)
    }
  }
  if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
    const page = fromJS({
      Props: {
        elements: state.getIn(['project', 'Settings', 'elements'], Map()),
      },
    })

    const elem = state.getIn(['project', 'Settings', 'elements', 'Footer'], Map()).toJS()
    ret = [...ret, ...getElementPushMappingData(elem, 'Footer', 'Footer', page, undefined, undefined, undefined, extra)]
  }

  state.getIn(['project', 'Settings', 'store', 'private'], Map()).map((row, id) => {
    if (row.get('type') == 'AUTO_PDF' && row.get('enablePushToSF', true)) {
      const pageName =
        state
          .getIn(['project', 'Pages'], List())
          .find((page) => page.get('_id') === row.get('targetPageID', ''))
          ?.get?.('name') ?? ''
      ret.push({
        value: id,
        label: 'Auto PDF: ' + row.get('label', pageName),
        group: 'docGen',
      })
    }
    if (row.get('type') == 'DOCGEN' && row.get('enablePushToSF', true)) {
      ret.push({
        value: id,
        label: 'DocGen: ' + row.get('label', row.get('templateName', '')),
        group: 'docGen',
      })

      let docGenLabel = String(row.get('label', row.get('templateName', '')))
      if (docGenLabel.endsWith('.docx')) {
        docGenLabel = docGenLabel.replace('.docx', '.sfdt')
      } else {
        docGenLabel += '.sfdt'
      }
      ret.push({
        value: 'sfdt:' + id,
        label: 'DocGen: ' + docGenLabel,
        group: 'docGen',
      })
    }
    if (row.get('type') == 'XLSXGEN' && row.get('enablePushToSF', true)) {
      ret.push({
        value: id,
        label: 'DocGen: ' + row.get('label', row.get('templateName', '')),
        group: 'docGen',
      })
    }
    if (row.get('type') === 'SLACK_SF') {
      ret.push({
        value: 'user',
        label: `${row.get('name', id)} / Slack Message / User`,
        group: `view:${id}`,
      })
      ret.push({
        value: 'message',
        label: `${row.get('name', id)} / Slack Message / Message`,
        group: `view:${id}`,
      })
      ret.push({
        value: 'timestamp',
        label: `${row.get('name', id)} / Slack Message / Timestamp`,
        group: `view:${id}`,
      })
      ret.push({
        value: 'name',
        label: `${row.get('name', id)} / Slack Message Files / File Name`,
        group: `view:${id}`,
      })
      ret.push({
        value: 'type',
        label: `${row.get('name', id)} / Slack Message Files / File Type`,
        group: `view:${id}`,
      })
      ret.push({
        value: 'body',
        label: `${row.get('name', id)} / Slack Message Files / File`,
        group: `view:${id}`,
      })
    }
  })
  const pageParams = state.getIn(['pages'], Map()).reduce((ret, page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage) {
      return _.concat(
        ret,
        page
          .getIn(['Props', 'params'], List())
          .map((param) => ({
            value: `${projectPage.get('uid')}:${param.get('id')}`,
            label: `[PV / ${projectPage.get('name', 'NoName')} / ${param.get('name')}]`,
            group: 'pageParam',
          }))
          .toJS()
      )
    } else {
      return ret
    }
  }, [])

  ret = ret.concat(pageParams)

  if (!state.getIn(['project', 'isPublic'], true)) {
    ret.push({
      value: 'id',
      label: 'SmartV Id',
      group: 'smartv',
    })
  }

  if (state.getIn(['project', 'Settings', 'otp', 'enabled'])) {
    ret.push({
      value: 'isOtpLogged',
      label: 'OTP IsLoggedIn',
      group: 'param',
    })

    ret.push({
      value: 'ftOtpSessionRemainingTimeSeconds',
      label: 'OTP Time Until Session Ends',
      group: 'param',
    })
  }

  if (state.getIn(['project', 'Settings', 'isDocGenAccess'])) {
    ret.push({
      value: 'record_id',
      label: 'Doc Gen RecordID',
      group: 'param',
    })
  } else if ([SURVEY_TYPE, SURVEY_EMAIL_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    ret.push({
      value: 'survey_taker_id',
      label: 'SurveyTakerId',
      group: 'param',
    })
    ret.push({
      value: 'survey_taker_titan_id',
      label: 'Survey Taker Titan Id',
      group: 'param',
    })
  } else if ([WORKFLOW_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    ret.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
  } else if (state.getIn(['project', 'ProjectType']) === SLACK_BOT_TYPE) {
    ret.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
    ret.push({
      value: 'slack_channel',
      label: 'Slack Channel',
      group: 'param',
    })
    const commands = state.getIn(['project', 'Settings', 'slackBot'], List())
    commands.map((command) => {
      const id = command.get('id')
      const name = command.get('command')
      command.get('fields', List()).map((field) => {
        ret.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / ${getCommandElementLabel(field.toJS())}]`,
          group: `view:${id}`,
        })
      })
      command.get('onSubmitCard', List()).map((field) => {
        ret.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / Card / ${field.get('label', '')}]`,
          group: `view:${id}`,
        })
      })
    })
  }

  if (state.getIn(['project', 'Settings', 'eCommerce', 'enable'])) {
    ret.push(
      ...[
        {
          value: 'eCommerce:transaction:id',
          label: 'Transaction ID',
          group: 'ecom',
        },
        {
          value: 'eCommerce:selected:ftValue',
          label: 'Selected Category / Value',
          group: 'ecom',
        },
        {
          value: 'eCommerce:selected:ftLabel',
          label: 'Selected Category / Label',
          group: 'ecom',
        },
        {
          value: 'eCommerce:subSelected:ftValue',
          label: 'Selected Sub Category / Value',
          group: 'ecom',
        },
        {
          value: 'eCommerce:subSelected:ftLabel',
          label: 'Selected Sub Category / Label',
          group: 'ecom',
        },
        {
          value: 'eCommerce:product',
          label: 'Selected Product',
          group: 'ecom',
        },
        {
          value: 'eCommerce:parentProduct',
          label: 'Parent Product',
          group: 'ecom',
        },
        {
          value: 'eCommerce:cart',
          label: 'Cart Items',
          group: 'ecom',
        },
        {
          value: 'eCommerce:search',
          label: 'Search',
          group: 'ecom',
        },
        {
          value: 'eCommerce:couponKey',
          label: 'Coupon Input Key',
          group: 'ecom',
        },
      ]
    )

    ret.push({
      value: 'eCommerce:checkoutForm:tax:totalWithoutTax',
      label: 'Cart Total before tax',
      group: 'ecom',
    })

    ret.push({
      value: 'eCommerce:checkoutForm:tax:total',
      label: 'Cart Total after Tax',
      group: 'ecom',
    })

    ret.push({
      value: 'eCommerce:checkoutForm:tax:taxPercent',
      label: 'Tax percent',
      group: 'ecom',
    })

    ret.push({
      value: 'eCommerce:checkoutForm:tax:taxValue',
      label: 'Total Tax',
      group: 'ecom',
    })

    ret.push({
      value: 'eCommerce:checkoutForm:shippingMethod',
      label: 'Shipping value',
      group: 'ecom',
    })
    ret.push({
      value: 'eCommerce:checkoutForm:shippingData:method',
      label: 'Shipping name',
      group: 'ecom',
    })
    ret.push({
      value: 'eCommerce:checkoutForm:shippingData:price',
      label: 'Shipping price',
      group: 'ecom',
    })
    ret.push({
      value: 'eCommerce:checkoutForm:shippingData:days',
      label: 'Shipping business days',
      group: 'ecom',
    })
    ret.push({
      value: 'eCommerce:checkoutForm:shippingData:arrivalDate',
      label: 'Shipping arrival date',
      group: 'ecom',
    })

    ret.push({
      value: `eCommerce:checkoutForm:shipping:deliveryMethod`,
      label: `Shipping Delivery`,
      group: 'ecom',
    })

    ret.push({
      value: `eCommerce:checkoutForm:shipping:isDelivery`,
      label: `Shipping Is Delivery`,
      group: 'ecom',
    })

    _.each(ADDRESS_FIELDS, ({ key, label }) => {
      ret.push({
        value: `eCommerce:checkoutForm:shipping:${key}`,
        label: `Shipping ${label}`,
        group: 'ecom',
      })
    })

    _.each(ADDRESS_FIELDS, ({ key, label }) => {
      ret.push({
        value: `eCommerce:checkoutForm:billing:${key}`,
        label: `Billing ${label}`,
        group: 'ecom',
      })
    })

    ret.push({
      value: `eCommerce:e_coupon:value`,
      label: `Coupon Key`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:e_coupon:discountNum`,
      label: `Coupon Discount`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:e_coupon:percent`,
      label: `Coupon Percent Discount`,
      group: 'ecom',
    })

    const productAttrs = state.getIn(
      ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productAttr'],
      List()
    )

    const productVariables = state.getIn(
      ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productVariables'],
      List()
    )

    productVariables.map((attr, index) => {
      ret.push({
        value: `eCommerce:productVar:${attr.get('id')}`,
        label: `Selected product Variable ${attr.get('name')}`,
        group: 'ecom',
      })
    })

    _.each(CART_ITEM_KEYS, ({ value, label }) => {
      ret.push({
        value: `eCommerce:cartData:${value}`,
        label: `Cart Item ${label}`,
        group: 'ecom',
      })
    })
    productAttrs.map((attr, index) => {
      ret.push({
        value: `eCommerce:cartData:attr:${index}:value`,
        label: `[Cart Item Attr / Value] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:cartData:attr:${index}:label`,
        label: `[Cart Item Attr / Label] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:cartData:attr:${index}:price`,
        label: `[Cart Item Attr / Delta Price] ${attr.get('label')}`,
        group: 'ecom',
      })
    })
    productVariables.map((attr, index) => {
      ret.push({
        value: `eCommerce:cartData:var:${attr.get('id')}`,
        label: `Cart Item Variable ${attr.get('name')}`,
        group: 'ecom',
      })
    })

    _.each(CART_ITEM_KEYS, ({ value, label }) => {
      ret.push({
        value: `eCommerce:item:${value}`,
        label: `Current Cart Item ${label}`,
        group: 'ecom',
      })
    })
    ret.push({
      value: `eCommerce:item:addons:Id`,
      label: `Current Cart Item Addon Id`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:name`,
      label: `Current Cart Item Addon Name`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:price`,
      label: `Current Cart Item Addon Price`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:discountPrice`,
      label: `Current Cart Item Addon Discount Price`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:count`,
      label: `Current Cart Item Addon count`,
      group: 'ecom',
    })
    productAttrs.map((attr, index) => {
      ret.push({
        value: `eCommerce:item:attr:${index}:value`,
        label: `[Current Cart Item Attr / Value] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:attr:${index}:label`,
        label: `[Current Cart Item Attr / Label] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:attr:${index}:price`,
        label: `[Current Cart Item Attr / Delta Price] ${attr.get('label')}`,
        group: 'ecom',
      })
    })
    productVariables.map((attr, index) => {
      ret.push({
        value: `eCommerce:item:var:${attr.get('id')}`,
        label: `Current Cart Item Variable ${attr.get('name')}`,
        group: 'ecom',
      })
    })

    // ret.push({
    //     value: `eCommerce:cartData:attr:0:value`,
    //     label: `Cart Item Attr 1 Value`,
    //     group: 'ecom'
    // })
    // ret.push({
    //     value: `eCommerce:cartData:attr:1:value`,
    //     label: `Cart Item Attr 2 Value`,
    //     group: 'ecom'
    // })
    // ret.push({
    //     value: `eCommerce:cartData:attr:2:value`,
    //     label: `Cart Item Attr 3 Value`,
    //     group: 'ecom'
    // })
    // ret.push({
    //     value: `eCommerce:cartData:attr:3:value`,
    //     label: `Cart Item Attr 4 Value`,
    //     group: 'ecom'
    // })
  }

  state.getIn(['project', 'Pages'], List()).map((projectPage) => {
    const uid = projectPage.get('uid')
    const page = state.getIn(['pages', projectPage.get('_id')], Map())
    const rootElems = page.getIn(['Props', 'Grid'], List())

    rootElems.map((id) => {
      const elem = page.getIn(['Props', 'elements', id], Map()).toJS()
      ret = [...ret, ...getElementPushMappingData(elem, id, uid, page, undefined, undefined, undefined, extra)]
    })
  })

  return ret
}

const getProjectElements = (key, elements) => {
  let ret = []
  elements
    .filter((elem) => elem.get('parent') === key)
    .map((val, uid) => {
      const elem = val.toJS()
      const isRepeat = false
      const isRepeatCol = false
      const tag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
      ret = [
        ...ret,
        ...getElementMappingData(
          elem,
          uid,
          key,
          fromJS({
            Props: {
              elements: elements,
            },
          }),
          isRepeat || isRepeatCol,
          uid,
          `[Repeat${isRepeatCol ? ' Col' : ''}]${tag ? ` ${tag || ''}` : ''}`
        ),
      ]
    })
  return ret
}

let prevStateEl = null
let resultsStateEl = null
export const getProjectElementsState = (state, isInCondition = false, noBool = false) => {
  if (prevStateEl === null || resultsStateEl === null || Date.now() - prevStateEl > 1000) {
    prevStateEl = Date.now()
    resultsStateEl = _getProjectElementsState(state)
    _.each(resultsStateEl, (option) => {
      if (option.options) {
        option.options = _.uniqBy(option.options, (val) => val.value)
      }
    })
  }
  return resultsStateEl
}
export const _getProjectElementsState = (state, isInCondition = false, noBool = false) => {
  const elements = noBool
    ? []
    : [
        {
          value: 'static',
          label: 'Boolean',
          options: [
            {
              value: 'true',
              label: 'Boolean True',
              group: 'static',
            },
            {
              value: 'false',
              label: 'Boolean False',
              group: 'static',
            },
          ],
        },
      ]

  if (state.getIn(['project', 'Settings', 'otp', 'enabled'])) {
    elements.push({
      value: 'isOtpLogged',
      label: 'OTP IsLoggedIn',
      options: [
        {
          value: 'isOtpLogged',
          label: 'OTP IsLoggedIn',
          group: 'param',
        },
      ],
    })

    elements.push({
      value: 'ftOtpSessionRemainingTimeSeconds',
      label: 'OTP Time Until Session Ends',
      options: [
        {
          value: 'ftOtpSessionRemainingTimeSeconds',
          label: 'OTP Time Until Session Ends',
          group: 'param',
        },
      ],
    })
  }

  if (isInCondition) {
    state
      .getIn(['envParams'], List())
      .filter((val) => val.get('isPublic', true))
      .map((val) => {
        elements.push({
          group: 'param',
          label: `[ENV]${val.get('name', '')}`,
          paramType: 'static',
          type: 'param',
          value: val.get('name'),
        })
      })
  }

  if (!state.getIn(['project', 'isPublic'], true)) {
    let smartv = []
    if (
      state.getIn(['project', 'Settings', 'SmartV', 'useRegister'], false) &&
      state.getIn(['project', 'Settings', 'SmartV', 'useCustomRegister'], false)
    ) {
      state.getIn(['project', 'Settings', 'SmartV', 'regConfig'], List()).map((elem) => {
        smartv.push({
          value: `${elem.get('uid')}`,
          label: `[SmartV / ${elem.get('label')}]`,
          group: 'smartvReg',
        })
      })
    }

    elements.push({
      value: 'smartv',
      label: 'SmartV',
      options: [
        {
          value: 'id',
          label: 'Id',
          group: 'smartv',
        },
        ...smartv,
      ],
    })
  }

  if (state.getIn(['project', 'Settings', 'ui', 'allowPushNotify'], false)) {
    elements.push({
      value: `pushNotifyHash`,
      label: `ft_webPush`,
      group: 'param',
    })
  }

  if (state.getIn(['project', 'Settings', 'eCommerce', 'enable'])) {
    const productAttrs = state.getIn(
      ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productAttr'],
      List()
    )
    const productVariables = state.getIn(
      ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productVariables'],
      List()
    )

    let ret = []
    _.each(CART_ITEM_KEYS, ({ value, label }) => {
      ret.push({
        value: `eCommerce:item:${value}`,
        label: `Current Cart Item ${label}`,
        group: 'ecom',
      })
    })
    ret.push({
      value: `eCommerce:item:addons:Id`,
      label: `Current Cart Item Addon Id`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:name`,
      label: `Current Cart Item Addon Name`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:price`,
      label: `Current Cart Item Addon Price`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:discountPrice`,
      label: `Current Cart Item Addon Discount Price`,
      group: 'ecom',
    })
    ret.push({
      value: `eCommerce:item:addons:count`,
      label: `Current Cart Item Addon count`,
      group: 'ecom',
    })
    productAttrs.map((attr, index) => {
      ret.push({
        value: `eCommerce:item:attr:${index}:value`,
        label: `[Current Cart Item Attr / Value] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:attr:${index}:label`,
        label: `[Current Cart Item Attr / Label] ${attr.get('label')}`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:attr:${index}:price`,
        label: `[Current Cart Item Attr / Delta Price] ${attr.get('label')}`,
        group: 'ecom',
      })
    })
    productVariables.map((attr, index) => {
      ret.push({
        value: `eCommerce:item:var:${attr.get('id')}`,
        label: `Current Cart Item Variable ${attr.get('name')}`,
        group: 'ecom',
      })
    })
    elements.push({
      value: 'ecom',
      label: 'eCommerce',
      options: [
        {
          value: 'eCommerce:transaction:id',
          label: 'Transaction ID',
          group: 'ecom',
        },
        {
          value: 'eCommerce:selected:ftValue',
          label: 'Selected Category / Value',
          group: 'ecom',
        },
        {
          value: 'eCommerce:selected:ftLabel',
          label: 'Selected Category / Label',
          group: 'ecom',
        },
        {
          value: 'eCommerce:subSelected:ftValue',
          label: 'Selected Sub Category / Value',
          group: 'ecom',
        },
        {
          value: 'eCommerce:subSelected:ftLabel',
          label: 'Selected Sub Category / Label',
          group: 'ecom',
        },
        {
          value: 'eCommerce:product',
          label: 'Selected Product',
          group: 'ecom',
        },
        {
          value: 'eCommerce:parentProduct',
          label: 'Parent Product',
          group: 'ecom',
        },
        ...productVariables
          .map((attr, index) => ({
            value: `eCommerce:productVar:${attr.get('id')}`,
            label: `Selected product Variable ${attr.get('name')}`,
            group: 'ecom',
          }))
          .toJS(),
        {
          value: 'eCommerce:cart',
          label: 'Cart Items',
          group: 'ecom',
        },
        {
          value: 'eCommerce:search',
          label: 'Search',
          group: 'ecom',
        },
        {
          value: 'eCommerce:couponKey',
          label: 'Coupon Input Key',
          group: 'ecom',
        },
        ..._.map(ADDRESS_FIELDS, ({ key, label }) => ({
          value: `eCommerce:checkoutForm:shipping:${key}`,
          label: `Shipping ${label}`,
          group: 'ecom',
        })),
        ..._.map(ADDRESS_FIELDS, ({ key, label }) => ({
          value: `eCommerce:checkoutForm:billing:${key}`,
          label: `Billing ${label}`,
          group: 'ecom',
        })),
        {
          value: 'eCommerce:checkoutForm:shipping:isDelivery',
          label: 'Shipping Is Delivery',
          group: 'ecom',
        },
        ...ret,
      ],
    })
  }

  const params = state.getIn(['project', 'Settings', 'params'], List())
  const portalParams = []
  params.map((param) => {
    portalParams.push({
      value: param.get('id'),
      label: param.get('name'),
      subType: param.get('paramType'),
      group: 'param',
    })
  })

  if (portalParams.length > 0) {
    elements.push({
      value: 'project',
      label: 'Params',
      options: portalParams,
    })
  }

  const processCustomElement =
    (type = 'Modal') =>
    (uid) => {
      const elem = state.getIn(['project', 'Settings', 'elements', uid], Map()).toJS()
      let fakePage = fromJS({
        Props: {
          elements: state.getIn(['project', 'Settings', 'elements'], Map()),
        },
      })

      const elems = getElementMappingData(elem, uid, 'project', fakePage)

      const pageElems = {
        value: `project:${type}`,
        label: type,
        options: _.sortBy(elems, 'label'),
      }
      if (elems.length > 0) {
        elements.push(pageElems)
      }
    }
  state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(processCustomElement('Drawer'))
  state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(processCustomElement('Modal'))

  const pageParams = state.getIn(['pages'], Map()).reduce((ret, page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage) {
      return _.concat(
        ret,
        page
          .getIn(['Props', 'params'], List())
          .map((param) => ({
            value: `${projectPage.get('uid')}:${param.get('id')}`,
            label: `[PV / ${projectPage.get('name', 'NoName')} / ${param.get('name')}]`,
            group: 'pageParam',
            subType: param.get('paramType'),
          }))
          .toJS()
      )
    } else {
      return ret
    }
  }, [])

  if (pageParams.length > 0) {
    elements.push({
      value: 'pageParams',
      label: 'Params',
      options: pageParams,
    })
  }

  if (state.getIn(['project', 'Settings', 'isDocGenAccess'])) {
    elements.push({
      value: 'record_id',
      label: 'Doc Gen RecordID',
      group: 'param',
    })
  } else if ([SURVEY_TYPE, SURVEY_EMAIL_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    elements.push({
      value: 'survey_taker_id',
      label: 'SurveyTakerId',
      group: 'param',
    })

    elements.push({
      value: 'survey_taker_titan_id',
      label: 'Survey Taker Titan Id',
      group: 'param',
    })
  } else if ([WORKFLOW_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    elements.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
  } else if (state.getIn(['project', 'ProjectType']) === 'chatBot') {
    const elems = getProjectElements('Header', state.getIn(['project', 'Settings', 'elements'], Map()))
    const pageElems = {
      value: 'project:Header',
      label: 'ChatBot',
      options: _.sortBy(elems, 'label'),
    }
    if (pageElems.options.length > 0) {
      elements.push(pageElems)
    }
  } else if (state.getIn(['project', 'ProjectType']) === SLACK_BOT_TYPE) {
    elements.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
    elements.push({
      value: 'slack_channel',
      label: 'Slack Channel',
      group: 'param',
    })
    const commands = state.getIn(['project', 'Settings', 'slackBot'], List())
    commands.map((command) => {
      const id = command.get('id')
      const name = command.get('command')
      let elems = []
      command.get('fields', List()).map((field) => {
        elems.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / ${getCommandElementLabel(field.toJS())}]`,
          group: `view:${id}`,
        })
      })
      command.get('onSubmitCard', List()).map((field) => {
        elems.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / Card / ${field.get('label', '')}]`,
          group: `view:${id}`,
        })
      })
      const pageElems = {
        value: `slack:${id}`,
        label: name,
        options: _.sortBy(elems, 'label'),
      }
      if (pageElems.options.length > 0) {
        elements.push(pageElems)
      }
    })
    state.getIn(['project', 'Settings', 'store', 'private'], Map()).map((config, id) => {
      if (config.get('type') === 'SLACK_SF') {
        elements.push({
          value: 'user',
          label: `${config.get('name', id)} / Slack Message / User`,
          group: `view:${id}`,
        })
        elements.push({
          value: 'message',
          label: `${config.get('name', id)} / Slack Message / Message`,
          group: `view:${id}`,
        })
        elements.push({
          value: 'timestamp',
          label: `${config.get('name', id)} / Slack Message / Timestamp`,
          group: `view:${id}`,
        })
        elements.push({
          value: 'name',
          label: `${config.get('name', id)} / Slack Message Files / File Name`,
          group: `view:${id}`,
        })
        elements.push({
          value: 'type',
          label: `${config.get('name', id)} / Slack Message Files / File Type`,
          group: `view:${id}`,
        })
        elements.push({
          value: 'body',
          label: `${config.get('name', id)} / Slack Message Files / File`,
          group: `view:${id}`,
        })
      }
    })
  }

  if (state.getIn(['project', 'Settings', 'Header', 'enable'], false)) {
    const elems = getProjectElements('Header', state.getIn(['project', 'Settings', 'elements'], Map()))
    const pageElems = {
      value: 'project:Header',
      label: 'Header',
      options: _.sortBy(elems, 'label'),
    }
    if (pageElems.options.length > 0) {
      elements.push(pageElems)
    }
  }
  if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
    const elems = getProjectElements('Footer', state.getIn(['project', 'Settings', 'elements'], Map()))
    const pageElems = {
      value: 'project:Footer',
      label: 'Footer',
      options: _.sortBy(elems, 'label'),
    }
    if (pageElems.options.length > 0) {
      elements.push(pageElems)
    }
  }

  state.getIn(['project', 'Pages'], List()).map((pageRec) => {
    const page = state.getIn(['pages', pageRec.get('_id')], Map())
    const elems = getPageElements(page, pageRec.get('uid'), isInCondition)
    const pageElems = {
      value: 'page:' + pageRec.get('_id'),
      label: pageRec.get('name', 'No name'),
      options: _.uniqBy(elems, 'value'),
      // options: _.sortBy(elems, 'label')
    }
    if (pageElems.options.length > 0) {
      elements.push(pageElems)
    }
  })

  return elements
}

const onlyUploadElements = (elem) => {
  if (isImmutable(elem) && elem.get('type') === 'FormField' && elem.getIn(['props', 'control']) === 'fileupload') {
    return true
  } else {
    return false
  }
}

export const getProjectFileUploadElements = (state, isNotEmptyItem) => {
  let ret = []
  if (!isNotEmptyItem) {
    ret.push(option('---', ''))
  }

  state.getIn(['project', 'Settings', 'params'], List()).map((row) => {
    if (row && row.get('paramType') == 'file') {
      ret.push({
        group: 'param',
        label: row.get('name'),
        type: 'param',
        uid: row.get('id'),
        value: row.get('id'),
      })
    }
  })
  let calEvents = state
    .getIn(['project', 'Settings', 'store', 'private'], Map())
    .filter((setting) => setting.get('type') === CALENDAR_EVENT_TYPE)
  if (calEvents.size > 0) {
    calEvents.map((event) => {
      ret.push({
        value: event.get('id'),
        label: `[Calendar] / ${event.getIn(['title', 'textValue'], 'Event')}`,
        uid: event.get('id'),
        group: 'calendar',
        type: CALENDAR_EVENT_TYPE,
      })
    })
  }

  if (state.getIn(['project', 'Settings', 'Header', 'enable'], false)) {
    const elems = getProjectElements(
      'Header',
      state.getIn(['project', 'Settings', 'elements'], Map()).filter(onlyUploadElements)
    )
    if (elems.length > 0) {
      ret = _.concat(ret, elems)
    }
  }
  if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
    const elems = getProjectElements(
      'Footer',
      state.getIn(['project', 'Settings', 'elements'], Map()).filter(onlyUploadElements)
    )
    if (elems.length > 0) {
      ret = _.concat(ret, elems)
    }
  }

  const processCustomElement = (uid) => {
    let fakePage = fromJS({
      Props: {
        elements: state.getIn(['project', 'Settings', 'elements'], Map()),
        Grid: [uid],
      },
    })
    const elems = getPageElements(fakePage, uid)
    ret = _.concat(
      ret,
      _.filter(elems, (elem) => elem.subType === 'fileupload')
    )
  }

  state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(processCustomElement)
  state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(processCustomElement)

  state.getIn(['project', 'Pages'], List()).map((pageRec) => {
    const uid = pageRec.get('uid')

    const elems = getPageElements(state.getIn(['pages', pageRec.get('_id')], Map()), uid)
    ret = _.concat(
      ret,
      _.filter(elems, (elem) => elem.subType === 'fileupload')
    )
  })

  return ret
}
export const getProjectExportElements = (state, notInclude = []) => {
  let ret = []

  state.getIn(['project', 'Pages'], List()).map((pageRec) => {
    const uid = pageRec.get('uid')

    const elems = getPageExportElements(state.getIn(['pages', pageRec.get('_id')], Map()), uid, notInclude)
    ret = _.concat(ret, elems)
  })

  return ret
}

export const getAllStripList = (state) => {
  let list = []

  state.getIn(['project', 'Pages'], List()).map((page) => {
    let pageData = state.getIn(['pages', page.get('_id'), 'Props', 'Grid'], List())
    pageData.map((stripID) => {
      let elem = state.getIn(['pages', page.get('_id'), 'Props', 'elements', stripID], Map())
      list.push({
        value: `${page.get('_id')}:${stripID}`,
        label: `${page.get('name', 'No Name')} / ${getElemName(elem.toJS())}`,
      })
    })
  })

  return list
}

let prevTabOrder = null
let prevTabOrderList = null
export const collectElementsTabOrder = (state) => {
  if (prevTabOrderList === null || Date.now() - prevMapping > 1000) {
    prevTabOrder = Date.now()
    prevTabOrderList = _collectElementsTabOrder(state)
  }
  return prevTabOrderList
}

const getAutoTabOrder = (state, PageID) => {
  const autoTabOrder = state.getIn(['project', 'Settings', 'ui', 'autoTabOrder'], false)
  if (PageID !== 'project') {
    return autoTabOrder && state.getIn(['pages', PageID, 'Props', 'TabOrder'], 'auto') === 'auto'
  } else {
    return autoTabOrder && state.getIn(['project', 'Settings', 'ui', 'TabOrder'], 'auto') === 'auto'
  }
}

const getComponentTabOrder = (uid, state, component, PageID) => {
  const index = 0
  const layoutMode = state.get('layoutMode', 'lg')

  let tabOrder = component.getIn(['props', layoutMode, 'tabOrder'], '')
  if (!tabOrder) return tabOrder
  let tabOrderNumber = Number(tabOrder)
  if (Number.isNaN(tabOrderNumber)) {
    return ''
  }

  const RepeatedStripsID = toJS(state.getIn(['project', 'Settings', 'RepeatedStripsID'], List())) || []
  const rootParent =
    getRootParent(component.get('parent'), state.getIn([...getElementDataRoot(PageID), 'elements'], Map()), true) ||
    component.get('parent') ||
    'a'

  const isRepeat = _.includes(RepeatedStripsID, rootParent)
  const { maxTabOrder, tabOrderHash } = collectParentChildrenCount(
    isRepeat ? rootParent : rootParent,
    [...getElementDataRoot(PageID), 'elements'],
    state
  )
  const rootParentType = state.getIn([...getElementDataRoot('project'), 'elements', rootParent, 'type'])

  let parent = ['Modal', 'DrawerEl'].includes(rootParentType) ? 'd' : 'a'
  let parentNumericPrefix
  // assume a max number of 10 elements in a parent node
  if (parent === 'Header') {
    parentNumericPrefix = 10
  } else if (parent === 'Footer') {
    parentNumericPrefix = 20
  } else {
    const prefixArray = _.map(parent, (char) => {
      if (Number(char) >= 0) return char
      return char.toLowerCase().charCodeAt(0) - 97
    }).join('')
    parentNumericPrefix = Number(prefixArray + '0') + 30
  }

  if (isRepeat) {
    const orderList = _.reduce(
      tabOrderHash,
      (r, v, k) => {
        if (v !== '') {
          return [...r, { id: k, order: parseInt(v, 10) }]
        } else {
          return r
        }
      },
      []
    )
    const sortedOrderList = _.sortBy(orderList, (val) => val.order)
    let tabIndex = _.findIndex(sortedOrderList, (val) => val.id === uid)
    if (index > 0) {
      return parseInt(maxTabOrder) + parentNumericPrefix + tabIndex + sortedOrderList.length * index
    } else {
      return tabOrderNumber + parentNumericPrefix
    }
  }

  try {
    if (tabOrderNumber > 0) tabOrderNumber += parentNumericPrefix
  } catch (err) {}

  return tabOrderNumber
}

const _collectElementsTabOrder = (state) => {
  let hash = {}
  let projectAutoTabOrder = getAutoTabOrder(state, 'project')

  const processProjectChild = (childID) => {
    if (List.isList(childID)) {
      return childID.map(processProjectChild)
    }
    if (projectAutoTabOrder) {
      hash[childID] = ''
    } else {
      let elem = state.getIn(['project', 'Settings', 'elements', childID], Map())
      let tabOrder = getComponentTabOrder(childID, state, elem, 'project')
      hash[childID] = tabOrder
      elem.get('children', List()).map(processProjectChild)
    }
  }

  const modals = state.getIn(['project', 'Settings', 'ui', 'Modal'], List())
  modals.map(processProjectChild)

  const drawers = state.getIn(['project', 'Settings', 'ui', 'Drawer'], List())
  drawers.map(processProjectChild)

  //process rest project elements(Footer/Header)
  state.getIn(['project', 'Settings', 'elements'], Map()).map((elem, elemID) => {
    if (['Footer', 'Header'].includes(elem.get('parent'))) {
      processProjectChild(elemID)
    }
  })

  state.getIn(['project', 'Pages'], List()).map((page) => {
    let pageAutoTabOrder = getAutoTabOrder(state, page.get('_id'))
    const processPageChild = (childID) => {
      if (List.isList(childID)) {
        return childID.map(processPageChild)
      }
      if (pageAutoTabOrder) {
        hash[childID] = ''
      } else {
        let elem = state.getIn(['pages', page.get('_id'), 'Props', 'elements', childID], Map())
        let tabOrder = getComponentTabOrder(childID, state, elem, page.get('_id'))
        hash[childID] = tabOrder
        elem.get('children', List()).map(processPageChild)
      }
    }

    state.getIn(['pages', page.get('_id'), 'Props', 'Grid'], List()).map(processPageChild)
  })

  return hash
}

let prevMapping = null
let resultsMapping = null
let prevParams = {
  isInCondition: null,
  activeStep: null,
}
export const getProjectMappingElements = (state, isInCondition = false, activeStep = null, isForce) => {
  if (isForce) {
    prevMapping = Date.now()
    prevParams.isInCondition = isInCondition
    prevParams.activeStep = activeStep
    return _getProjectMappingElements(state, isInCondition, activeStep)
  }
  if (
    prevMapping === null ||
    resultsMapping === null ||
    Date.now() - prevMapping > 2000 ||
    prevParams.isInCondition !== isInCondition ||
    prevParams.activeStep !== activeStep
  ) {
    prevParams.isInCondition = isInCondition
    prevParams.activeStep = activeStep
    prevMapping = Date.now()
    resultsMapping = _getProjectMappingElements(state, isInCondition, activeStep)
  }
  return resultsMapping
}

export const getProjectParamsFolders = (state) => {
    return state.getIn(['project', 'Settings', 'paramsFolder'], List()).toJS();
}

export const _getProjectMappingElements = (state, isInCondition = false, activeStep) => {
  let ret = []
  if (isInCondition) {
    state
      .getIn(['envParams'], List())
      .filter((val) => val.get('isPublic', true))
      .map((val) => {
        ret.push({
          group: 'param',
          label: `[ENV]${val.get('name', '')}`,
          paramType: 'static',
          type: 'param',
          value: val.get('name'),
        })
      })
  }
  ret = _.concat(
    [],
    ret,
    filterEditableParameters(
      state.getIn(['project', 'Settings', 'params'], List()).concat(state.getIn(['project', 'params'], List())),
      isInCondition
    )
      .map((param) => ({
        paramType: param.get('paramType'),
        value: `${param.get('id')}`,
        label: `[GV / ${param.get('name')}]`,
        group: 'param',
        type: 'param',
      }))
      .toJS()
  )

  if (!state.getIn(['project', 'isPublic'], true)) {
    ret.push({
      paramType: 'static',
      value: 'ftSessLeftTime',
      label: 'SmartV Session Time',
      group: 'param',
    })
  }

  // if (!state.getIn(['project', 'isPublic'], true)) {
  //     ret.push({
  //         paramType: 'static',
  //         value: 'id',
  //         label: 'SmartV Id',
  //         group: 'smartv'
  //     })
  // }

  if (state.getIn(['project', 'Settings', 'otp', 'enabled'])) {
    ret.push({
      paramType: 'static',
      value: 'isOtpLogged',
      label: 'OTP IsLoggedIn',
      group: 'param',
    })

    ret.push({
      paramType: 'static',
      value: 'ftOtpSessionRemainingTimeSeconds',
      label: 'OTP Time Until Session Ends',
      group: 'param',
    })
  }
  if (!state.getIn(['project', 'isPublic'], true)) {
    ret.push({
      paramType: 'static',
      value: 'isLogged',
      label: 'SmartV IsLoggedIn',
      group: 'param',
    })
  }

  if (state.getIn(['project', 'ProjectType'], 'web') == 'surveyEmail') {
    ret.push({
      paramType: 'static',
      value: `surveyValue`,
      label: `Value`,
      group: 'param',
    })
  }

  if (state.getIn(['project', 'Settings', 'ui', 'allowPushNotify'], false)) {
    ret.push({
      paramType: 'static',
      value: `pushNotifyHash`,
      label: `ft_webPush`,
      group: 'param',
    })
  }

  if (state.getIn(['project', 'ProjectType'], 'web') !== WORKFLOW_TYPE) {
    ret.push({
      paramType: 'static',
      value: `device`,
      label: `Current Device`,
      group: 'pageParam',
    })
  }

  let smartv = []
  if (
    state.getIn(['project', 'Settings', 'SmartV', 'useRegister'], false) &&
    state.getIn(['project', 'Settings', 'SmartV', 'useCustomRegister'], false)
  ) {
    state.getIn(['project', 'Settings', 'SmartV', 'regConfig'], List()).map((elem) => {
      smartv.push({
        value: `${elem.get('uid')}`,
        label: `[SmartV / ${elem.get('label')}]`,
        group: 'smartvReg',
      })
    })
  }
  ret = _.concat(ret, smartv)

  ///@todo uncomment for 16997
  state.getIn(['project', 'Settings', 'store', 'private'], Map()).map((elem, id) => {
    if (elem.get('type') === 'AUTO_PDF') {
      ret.push({
        value: id,
        label: `[Auto PDF] ${elem.get('label')}`,
        group: 'docGen',
      })
    }
    if (elem.get('type') == 'DOCGEN') {
      ret.push({
        value: id,
        label: 'DocGen: ' + elem.get('label', elem.get('templateName', '')),
        group: 'docGen',
      })
      let docGenLabel = String(elem.get('label', elem.get('templateName', '')))
      if (docGenLabel.endsWith('.docx')) {
        docGenLabel = docGenLabel.replace('.docx', '.sfdt')
      } else {
        docGenLabel += '.sfdt'
      }
      ret.push({
        value: 'sfdt:' + id,
        label: 'DocGen: ' + docGenLabel,
        group: 'docGen',
      })
    }
    if (elem.get('type') == 'XLSXGEN') {
      ret.push({
        value: id,
        label: 'DocGen: ' + elem.get('label', elem.get('templateName', '')),
        group: 'docGen',
      })
    }
  })

  const pageParams = state.getIn(['pages'], Map()).reduce((ret, page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage) {
      return _.concat(
        ret,
        filterEditableParameters(page.getIn(['Props', 'params'], List()), isInCondition)
          .map((param) => ({
            paramType: param.get('paramType'),
            value: `${projectPage.get('uid')}:${param.get('id')}`,
            label: `[PV / ${projectPage.get('name', 'NoName')} / ${param.get('name')}]`,
            group: 'pageParam',
          }))
          .toJS()
      )
    } else {
      return ret
    }
  }, [])

  ret = _.concat(ret, pageParams)

  if (state.getIn(['project', 'ProjectType']) === 'chatBot') {
    const elems = getProjectElements('Header', state.getIn(['project', 'Settings', 'elements'], Map()))
    if (elems.length > 0) {
      ret = _.concat(ret, elems)
    }
  }

  if (state.getIn(['project', 'Settings', 'isDocGenAccess'])) {
    ret.push({
      value: 'record_id',
      label: 'Doc Gen RecordID',
      group: 'param',
    })
  } else if ([SURVEY_TYPE, SURVEY_EMAIL_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    ret.push({
      value: 'survey_taker_id',
      label: 'SurveyTakerId',
      group: 'param',
    })

    ret.push({
      value: 'survey_taker_titan_id',
      label: 'Survey Taker Titan Id',
      group: 'param',
    })
  } else if ([WORKFLOW_TYPE].indexOf(state.getIn(['project', 'ProjectType'])) > -1) {
    ret.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
  } else if (state.getIn(['project', 'ProjectType']) === SLACK_BOT_TYPE) {
    ret.push({
      value: 'record_id',
      label: 'RecordID',
      group: 'param',
    })
    ret.push({
      value: 'slack_channel',
      label: 'Slack Channel',
      group: 'param',
    })
    const commands = state.getIn(['project', 'Settings', 'slackBot'], List())
    commands.map((command) => {
      const id = command.get('id')
      const name = command.get('command')
      command.get('fields', List()).map((field) => {
        ret.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / ${getCommandElementLabel(field.toJS())}]`,
          group: `view:${id}`,
        })
      })
      command.get('onSubmitCard', List()).map((field) => {
        ret.push({
          value: `slack:${id}:${field.get('id')}`,
          label: `[${name} / Card / ${field.get('label', '')}]`,
          group: `view:${id}`,
        })
      })
    })
    state.getIn(['project', 'Settings', 'store', 'private'], Map()).map((config, id) => {
      if (config.get('type') === 'SLACK_SF') {
        ret.push({
          value: 'user',
          label: `${config.get('name', id)} / Slack Message / User`,
          group: `view:${id}`,
        })
        ret.push({
          value: 'message',
          label: `${config.get('name', id)} / Slack Message / Message`,
          group: `view:${id}`,
        })
        ret.push({
          value: 'timestamp',
          label: `${config.get('name', id)} / Slack Message / Timestamp`,
          group: `view:${id}`,
        })
        ret.push({
          value: 'name',
          label: `${config.get('name', id)} / Slack Message Files / File Name`,
          group: `view:${id}`,
        })
        ret.push({
          value: 'type',
          label: `${config.get('name', id)} / Slack Message Files / File Type`,
          group: `view:${id}`,
        })
        ret.push({
          value: 'body',
          label: `${config.get('name', id)} / Slack Message Files / File`,
          group: `view:${id}`,
        })
      }
    })
  }

  if (state.getIn(['project', 'Settings', 'Header', 'enable'], false)) {
    const elems = getProjectElements('Header', state.getIn(['project', 'Settings', 'elements'], Map()))
    if (elems.length > 0) {
      ret = _.concat(ret, elems)
    }
  }
  if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
    const elems = getProjectElements('Footer', state.getIn(['project', 'Settings', 'elements'], Map()))
    if (elems.length > 0) {
      ret = _.concat(ret, elems)
    }
  }

  const processCustomElement = (uid) => {
    const elem = state.getIn(['project', 'Settings', 'elements', uid], Map()).toJS()
    let fakePage = fromJS({
      Props: {
        elements: state.getIn(['project', 'Settings', 'elements'], Map()),
      },
    })
    const elems = getElementMappingData(elem, uid, 'project', fakePage, undefined, undefined, undefined, isInCondition)
    ret = _.concat(ret, elems)
  }
  state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(processCustomElement)
  state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(processCustomElement)

  if (state.getIn(['project', 'Settings', 'eCommerce', 'enable'])) {
    ret.push({
      value: 'eCommerce:transaction:id',
      label: 'Transaction ID',
      group: 'ecom',
    })
    ret.push({
      value: 'eCommerce:e_catalog:logo',
      label: 'ECommerce Logo',
      group: 'ecom',
    })
    ret = ret.concat([
      {
        value: 'eCommerce:selected:ftValue',
        label: 'Selected Category / Value',
        group: 'ecom',
      },
      {
        value: 'eCommerce:selected:ftLalue',
        label: 'Selected Category / Label',
        group: 'ecom',
      },
      {
        value: 'eCommerce:subSelected:ftValue',
        label: 'Selected Sub Category / Value',
        group: 'ecom',
      },
      {
        value: 'eCommerce:subSelected:ftLalue',
        label: 'Selected Sub Category / Label',
        group: 'ecom',
      },
      {
        value: 'eCommerce:couponKey',
        label: 'Coupon Input Key',
        group: 'ecom',
      },
      {
        value: 'eCommerce:cart',
        label: 'Cart Items HTML',
        group: 'ecom',
      },
      ..._.map(ADDRESS_FIELDS, ({ key, label }) => ({
        value: `eCommerce:checkoutForm:shipping:${key}`,
        label: `Shipping ${label}`,
        group: 'ecom',
      })),
      ..._.map(ADDRESS_FIELDS, ({ key, label }) => ({
        value: `eCommerce:checkoutForm:billing:${key}`,
        label: `Billing ${label}`,
        group: 'ecom',
      })),
    ])

    if (isInCondition) {
      const productAttrs = state.getIn(
        ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productAttr'],
        List()
      )

      const productVariables = state.getIn(
        ['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productVariables'],
        List()
      )

      _.each(CART_ITEM_KEYS, ({ value, label }) => {
        ret.push({
          value: `eCommerce:item:${value}`,
          label: `Current Cart Item ${label}`,
          group: 'ecom',
        })
      })
      ret.push({
        value: `eCommerce:item:addons:Id`,
        label: `Current Cart Item Addon Id`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:addons:name`,
        label: `Current Cart Item Addon Name`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:addons:price`,
        label: `Current Cart Item Addon Price`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:addons:discountPrice`,
        label: `Current Cart Item Addon Discount Price`,
        group: 'ecom',
      })
      ret.push({
        value: `eCommerce:item:addons:count`,
        label: `Current Cart Item Addon count`,
        group: 'ecom',
      })
      productAttrs.map((attr, index) => {
        ret.push({
          value: `eCommerce:item:attr:${index}:value`,
          label: `[Current Cart Item Attr / Value] ${attr.get('label')}`,
          group: 'ecom',
        })
        ret.push({
          value: `eCommerce:item:attr:${index}:label`,
          label: `[Current Cart Item Attr / Label] ${attr.get('label')}`,
          group: 'ecom',
        })
        ret.push({
          value: `eCommerce:item:attr:${index}:price`,
          label: `[Current Cart Item Attr / Delta Price] ${attr.get('label')}`,
          group: 'ecom',
        })
      })
      productVariables.map((attr, index) => {
        ret.push({
          value: `eCommerce:item:var:${attr.get('id')}`,
          label: `Current Cart Item Variable ${attr.get('name')}`,
          group: 'ecom',
        })
      })
    }
  }

  const isSurvey = ['survey'].includes(state.getIn(['project', 'ProjectType'], 'web'))

  state.getIn(['project', 'Pages'], List()).map((pageRec) => {
    const uid = pageRec.get('uid')

    const elems = getPageElements(
      state.getIn(['pages', pageRec.get('_id')], Map()),
      uid,
      isInCondition,
      isSurvey,
      activeStep
    )
    ret = _.concat(ret, elems)
  })
  return ret
}

const getElementActions = (
  child,
  id,
  uid,
  page,
  isRepeat = false,
  isRepeatCol = false,
  repeatUID,
  repeatLabel = 'Repeat',
  isExport = false,
  filterType = null,
  state,
  device = 'lg'
) => {
  let ret = []
  if (String(id).indexOf('fit_') > -1) {
    return ret
  }
  const push = (value, uid, text, type, parent, isPreventSelect = false) => {
    return ret.push({
      value,
      uid,
      text:
        uid === 'Header' || uid === 'Footer'
          ? `[${uid}] / ${isRepeat || isRepeatCol ? `${repeatLabel} / ${text}` : text}`
          : isRepeat || isRepeatCol
            ? `${repeatLabel} / ${text}`
            : text,
      type,
      parent,
      isPreventSelect,
    })
  }

  const valueStart = isRepeat || isRepeatCol ? `${uid}:${repeatUID}:${id}` : `${uid}:${id}`

  if (
    filterType !== null &&
    child.type !== filterType &&
    child.type === 'Widget' &&
    child?.props?.data?.Type !== filterType
  ) {
    _.each(_.flatten(child.children), (childUID) => {
      if (childUID === id) {
        return []
      }
      const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
      if (_.isArray(elem.children)) {
        elem.children = _.filter(elem.children, (child) => {
          if (_.isArray(child)) {
            return _.filter(child, (id) => id !== childUID)
          } else {
            return child !== childUID
          }
        })
      }
      ret = [
        ...ret,
        ...getElementActions(
          elem,
          childUID,
          uid,
          page,
          isRepeat,
          isRepeatCol,
          repeatUID,
          repeatLabel,
          isExport,
          filterType,
          state,
          device
        ),
      ]
    })
  } else {
    if (child.type === 'Widget' && _.get(child, ['props', 'data', 'Props', 'ChartType']) === 'doughnut') {
      let rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      if (!rawTag) {
        rawTag = _.get(child, 'props.lg.label', '')
      }
      let tag = rawTag ? ` ${rawTag}` : ''
      push(`${valueStart}-innerText`, uid, buildElementLabel(tag, getDisplayType('doughnut'), 'Inner Text'), child.type)
    }
    if (!_.isEmpty(child) && child?.type && child?.type !== 'Widget') {
      let rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      if (!rawTag) {
        rawTag = _.get(child, 'props.lg.label', '')
      }
      let tag = rawTag ? ` ${rawTag}` : ''
      if (!tag && state) {
        if (state.getIn(['project', 'ProjectType']) == 'survey') {
          let component = page.getIn(['Props', 'elements', id])
          if (component && component.get('type') != 'PageConditionalForm"') {
            let parentC = page.getIn(['Props', 'elements', component.get('parent')])
            if (parentC && parentC.getIn(['type']) == 'PageConditionalForm') {
              let tabs = parentC.getIn(['props', 'lg', 'tabs'], List())
              let slideIndex = 1
              tabs.map((tab) => {
                let questionIndex = tab.get('children', List()).indexOf(id)
                if (questionIndex > -1) {
                  let slideName = tab.get('label')
                  if (!slideName) {
                    slideName = `Slide ${slideIndex}`
                  }
                  let title = tab.getIn(['info', id, 'title'], '')
                  if (!title) {
                    title = getDisplayType(child.type)
                  }
                  tag = slideName + '.' + title
                }
                if (!tab.get('isStart')) {
                  slideIndex++
                }
              })
            }
          }
        }
      }

      if (child?.type === 'Strip' && !isExport) {
        if (isRepeat || isRepeatCol) {
          tag = ''
        }
        push(`${valueStart}`, uid, buildElementLabel(tag, child.type), child.type)
        const style = page.getIn(['Props', 'styles', _.get(child, ['props', 'styleRef'])], Map())
        const { areas } = getGridData(style, 'lg')
        const plainAreas = _.uniq(areas.flatten(2).toJS())
        _.each(plainAreas, (area) => {
          let areaTag = getElemName(child, area)
          push(`${valueStart}-${area}`, uid, buildElementLabel(tag, `Strip Col`, areaTag), child.type)
        })
        push(`${uid}:${id}:ftIsSelVal`, uid, buildElementLabel(tag, `Strip`, 'Is Selected'), child.type)
        if (child?.props?.isRepeat || child?.props?.isRepeatCol) {
          _.each(filterEditableParametersJS(_.get(child, ['props', 'params'], [])), function (param) {
            push(`${uid}:${id}:${param.id}`, uid, buildElementLabel(tag, `SP`, param.name), child.type)
          })
        }
      } else if (child?.type === 'DiffViewer' && !isExport) {
        push(`${valueStart}:left`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Old'), child.type)
        push(`${valueStart}:right`, uid, buildElementLabel(tag, getDisplayType(child.type), 'New'), child.type)
      } else if (child?.type === 'TextReview' && !isExport) {
        push(valueStart, uid, buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(`${valueStart}:old`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Old'), child.type)
        push(`${valueStart}:new`, uid, buildElementLabel(tag, getDisplayType(child.type), 'New'), child.type)
        push(`${valueStart}:draft`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Draft'), child.type)
      } else if (child?.type === 'Range' && !isExport) {
        push(`${valueStart}`, uid, buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(`${valueStart}:min`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Min'), child.type)
        push(`${valueStart}:max`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Max'), child.type)
      } else if (child?.type === 'Counter' && !isExport) {
        push(`${valueStart}`, 'value', buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(`${valueStart}:VALUE`, 'value', buildElementLabel(tag, getDisplayType(child.type), 'Value'), child.type)
        if (_.get(child, 'props.mode', COUNTER_MODE_COUNT) === COUNTER_MODE_INTERVAL) {
          push(
            `${valueStart}:VALUE_STEP`,
            'valueStep',
            buildElementLabel(tag, getDisplayType(child.type), 'Value Step'),
            child.type
          )
        }
      } else if (child?.type === 'GoogleMap' && !isExport) {
        push(`${valueStart}`, 'value', buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(
          `${valueStart}:lat`,
          'value',
          buildElementLabel(tag, getDisplayType(child.type), 'Marker Latitude'),
          child.type
        )
        push(
          `${valueStart}:lng`,
          'value',
          buildElementLabel(tag, getDisplayType(child.type), 'Marker Longitude'),
          child.type
        )
        push(
          `${valueStart}:text`,
          'value',
          buildElementLabel(tag, getDisplayType(child.type), 'Marker Text'),
          child.type
        )
        push(
          `${valueStart}:color`,
          'value',
          buildElementLabel(tag, getDisplayType(child.type), 'Marker Pin Color'),
          child.type
        )
        push(
          `${valueStart}:address`,
          'value',
          buildElementLabel(tag, getDisplayType(child.type), 'Marker Address'),
          child.type
        )
        push(`${valueStart}:zoom`, 'value', buildElementLabel(tag, getDisplayType(child.type), 'Zoom'), child.type)
      } else if (child?.type === 'Ranking' && !isExport) {
        if (_.get(child, ['props', 'source'], 'static') === 'sf') {
          push(`${valueStart}`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Item Index'), child.type)
          push(`${valueStart}:value`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Item Value'), child.type)
          push(`${valueStart}:label`, uid, buildElementLabel(tag, getDisplayType(child.type), 'Item Label'), child.type)
        } else {
          _.map(_.get(child, ['props', 'items']), (row) => {
            push(
              `${valueStart}:items:${row.uid}`,
              uid,
              buildElementLabel(tag, getDisplayType(child.type), row.label),
              child.type
            )
            push(
              `${valueStart}:${row.uid}`,
              uid,
              buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Index'),
              child.type
            )
            push(
              `${valueStart}:${row.uid}-value`,
              uid,
              buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Value'),
              child.type
            )
            push(
              `${valueStart}:${row.uid}-label`,
              uid,
              buildElementLabel(tag, getDisplayType(child.type), row.label + ' / Label'),
              child.type
            )
          })
        }
      } else if (child?.type === 'CircleSlider' && !isExport) {
        push(`${valueStart}`, 'value', buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(`${valueStart}:value`, 'value', buildElementLabel(tag, getDisplayType(child.type), 'Value'), child.type)
        push(`${valueStart}:min`, 'min', buildElementLabel(tag, getDisplayType(child.type), 'Min Value'), child.type)
        push(`${valueStart}:max`, 'max', buildElementLabel(tag, getDisplayType(child.type), 'Max Value'), child.type)
        if (child?.props?.v2) {
          push(
            `${valueStart}:maxTrackValue`,
            'maxTrackValue',
            buildElementLabel(tag, getDisplayType(child.type), 'Max Track Value'),
            child.type
          )
          push(
            `${valueStart}:prefix`,
            'prefix',
            buildElementLabel(tag, getDisplayType(child.type), 'Prefix'),
            child.type
          )
          push(
            `${valueStart}:suffix`,
            'suffix',
            buildElementLabel(tag, getDisplayType(child.type), 'Suffix'),
            child.type
          )
        } else {
          push(
            `${valueStart}:stepSize`,
            'stepSize',
            buildElementLabel(tag, getDisplayType(child.type), 'Step Size'),
            child.type
          )
        }
      } else if (child?.type === 'TreeView' && !isExport) {
        push(`${valueStart}:value`, 'value', buildElementLabel(tag, getDisplayType(child.type), 'Value'), child.type)
        push(`${valueStart}:header`, 'header', buildElementLabel(tag, getDisplayType(child.type), 'Header'), child.type)
        push(
          `${valueStart}:description`,
          'description',
          buildElementLabel(tag, getDisplayType(child.type), 'Description'),
          child.type
        )
        push(`${valueStart}:icon`, 'icon', buildElementLabel(tag, getDisplayType(child.type), 'Icon'), child.type)
        push(`${valueStart}:parent`, 'parent', buildElementLabel(tag, getDisplayType(child.type), 'Parent'), child.type)
      } else if (child?.type === 'FileViewer' && !isExport) {
        push(`${valueStart}`, 'url', buildElementLabel(tag, getDisplayType(child.type)), child.type)
        push(`${valueStart}:url`, 'url', buildElementLabel(tag, getDisplayType(child.type), 'Content'), child.type)
        push(`${valueStart}:type`, 'type', buildElementLabel(tag, getDisplayType(child.type), 'Type'), child.type)
      } else if (child?.type === 'FormField' && !isExport) {
        const control = _.capitalize(getDisplayType(_.get(child, 'props.control', 'text')))
        push(`${valueStart}`, uid, buildElementLabel(tag, `FormField / ${control}`), child.type)
        if (_.get(child, 'props.control', 'text') == 'lookup') {
          push(`${valueStart}:ft_value`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Value'), child.type)
          push(`${valueStart}:ft_text`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Label'), child.type)
        } else if (LIST_BASED_FIELDS.indexOf(_.get(child, 'props.control', 'text')) > -1) {
          push(`${valueStart}:ftListValue`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Value'), child.type)
          push(`${valueStart}:ftListLabel`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Label'), child.type)
          if (_.get(child, 'props.control', 'text') == 'multiSelect') {
            push(
              `${valueStart}:selectedCount`,
              uid,
              buildElementLabel(tag, `FormField / ${control}`, 'Selected Count'),
              child.type
            )
          }
          if (_.get(child, ['props', 'source'], 'static') === 'static') {
            _.each(_.get(child, 'props.items', []), (item) => {
              push(
                `${valueStart}:items:${item.uid}`,
                uid,
                buildElementLabel(tag, `FormField / ${control} / Items`, item.label),
                child.type
              )
            })
          }
        } else if (
          _.get(child, 'props.control', 'text') === 'checkbox' &&
          _.get(child, 'props.source', 'single') !== 'single'
        ) {
          push(`${valueStart}:ftListValue`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Value'), child.type)
          push(`${valueStart}:ftListLabel`, uid, buildElementLabel(tag, `FormField / ${control}`, 'Label'), child.type)
        }
        if (
          _.get(child, 'props.control', 'text') === 'checkbox' &&
          _.get(child, ['props', 'source'], 'single') === 'static'
        ) {
          _.each(_.get(child, 'props.items', []), (item) => {
            push(
              `${valueStart}:items:${item.uid}`,
              uid,
              buildElementLabel(tag, `FormField / ${control} / Items`, item.label),
              child.type
            )
          })
        }
        if (
          _.get(child, 'props.control', 'text') === 'signature' &&
          _.get(child, ['props', 'lg', 'isCompanyMode'], false)
        ) {
          push(
            `${valueStart}-companyName`,
            uid,
            buildElementLabel(tag, `FormField / ${control}`, 'Company Name'),
            child.type
          )
          push(
            `${valueStart}-companyLabRegNum`,
            uid,
            buildElementLabel(tag, `FormField / ${control}`, 'Label Reg number'),
            child.type
          )
          push(
            `${valueStart}-companyRegNum`,
            uid,
            buildElementLabel(tag, `FormField / ${control}`, 'Company Reg Number'),
            child.type
          )
        }
        if (_.get(child, 'props.control', 'text') === 'daterange') {
          push(
            `${valueStart}:startDate`,
            uid,
            buildElementLabel(tag, `FormField / ${control}`, 'Start Date'),
            child.type
          )
          push(`${valueStart}:endDate`, uid, buildElementLabel(tag, `FormField / ${control}`, 'End Date'), child.type)
        }
      } else if (child?.type === 'DrawerEl' || child?.type === 'Modal') {
        push(`${valueStart}`, uid, `[${getDisplayType(child.type)}]${tag}`, child.type)
        if (!isExport) {
          if (child.props.isExp) {
            let rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
            _.each(child.props.lg?.tabs, (tab) => {
              _.each(tab.children, (childUID) => {
                if (childUID === id) {
                  return []
                }
                const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
                let childElements = getElementActions(
                  elem,
                  childUID,
                  id,
                  page,
                  isRepeat,
                  isRepeatCol,
                  repeatUID,
                  repeatLabel,
                  isExport,
                  (filterType = null),
                  state,
                  device
                )
                _.each(childElements, (elem) => {
                  elem.text = `[Modal] ${rawTag} / ${tab.label} / ${elem.text}`
                  ret.push(elem)
                })
              })
            })
          } else {
            _.each(_.flatten(child.children), (childUID) => {
              if (childUID === id) {
                return []
              }
              const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
              ret = [
                ...ret,
                ...getElementActions(
                  elem,
                  childUID,
                  id,
                  page,
                  isRepeat,
                  isRepeatCol,
                  repeatUID,
                  repeatLabel,
                  isExport,
                  (filterType = null),
                  state,
                  device
                ),
              ]
            })
          }
        }
      } else if (child?.type === 'Form') {
        if (isExport) {
          push(`${valueStart}`, uid, `[${getDisplayType(child.type)}]${tag}`, child.type)
        } else {
          push(`${valueStart}`, uid, `[${getDisplayType(child.type)}]${tag}`, child.type)
          push(
            `${valueStart}-cols`,
            uid,
            `[${getDisplayType(child.type)} / Columns]${tag}`,
            child.type,
            `${valueStart}`,
            true
          )
          push(
            `${valueStart}-rows`,
            uid,
            `[${getDisplayType(child.type)} / Rows]${tag}`,
            child.type,
            `${valueStart}`,
            true
          )
          if (_.has(child, ['props', device, 'cols']) && _.has(child, ['props', device, 'children'])) {
            _.times(_.get(child, ['props', device, 'cols'], 1), (col) => {
              push(
                `${valueStart}-col:c${col}`,
                uid,
                `[${getDisplayType(child.type)} Col ${String.fromCharCode('A'.charCodeAt(0) + col)}]${tag}`,
                child.type,
                `${valueStart}-cols`
              )
            })
            _.each(_.get(child, ['props', device, 'children'], {}), (row, rowID) => {
              push(
                `${valueStart}-row:${rowID}`,
                uid,
                `[${getDisplayType(child.type)} Row / ${row?.tag || rowID} ${row?.originRow ? `(${row?.originRow})` : ''}]${tag}`,
                child.type,
                `${valueStart}-rows`
              )
            })
            _.each(_.get(child, ['props', device, 'children'], {}), (row, rowID) => {
              _.each(_.get(row, 'children', {}), function (cell, cellID) {
                push(
                  `${valueStart}-cell:${cellID}`,
                  uid,
                  `[${getDisplayType(child.type)} Cell / ${cell?.tag || cellID}]${tag}`,
                  child.type,
                  `${valueStart}-row:${rowID}`
                )
              })
            })
          } else {
            _.times(_.get(child, 'props.lg.cols', 1), (col) => {
              push(
                `${valueStart}-col:c${col}`,
                uid,
                `[${getDisplayType(child.type)} Col ${col + 1}]${tag}`,
                child.type,
                `${valueStart}-cols`
              )
            })
            _.each(_.get(child, 'props.lg.children', {}), (row, rowID) => {
              push(
                `${valueStart}-row:${rowID}`,
                uid,
                `[${getDisplayType(child.type)} Row / ${row?.tag || rowID}]${tag}`,
                child.type,
                `${valueStart}-rows`
              )
            })
            _.each(_.get(child, 'props.lg.children', {}), (row, rowID) => {
              _.each(_.get(row, 'children', {}), function (cell, cellID) {
                push(
                  `${valueStart}-cell:${cellID}`,
                  uid,
                  `[${getDisplayType(child.type)} Cell / ${cell?.tag || cellID}]${tag}`,
                  child.type,
                  `${valueStart}-row:${rowID}`
                )
              })
            })
          }
        }
      } else if (child?.type === 'PowerTable') {
        const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``
        push(
          `${valueStart}`,
          uid,
          buildElementLabel(tag, `${subTag}${getDisplayType(_.get(child, 'type'))}`),
          child.type
        )
        push(
          `${valueStart}:list_row_style`,
          'list_row_style',
          buildElementLabel(tag, `${subTag}${getDisplayType(_.get(child, 'type'))}`, 'Row Style'),
          'listRowStyle'
        )

        const processColumn = (col) => {
          if (_.size(_.get(col, 'columns', [])) === 0) {
            push(
              `${valueStart}:${col.id}`,
              `PowerTableWidget:${col.id}`,

              buildElementLabel(tag, `${subTag}[${getDisplayType(_.get(child, 'type'))}`, `${col.Header || 'Col'}]`),
              'PowerTableWidget'
            )
            if (!_.isEmpty(_.get(col, 'meta.subCtrl.Props', {}))) {
              let el = {}
              const subTag = Boolean(_.get(col, 'meta.subCtrl.Props.tag'))
                ? `[${col.Header || 'Col'}]${_.get(col, 'meta.subCtrl.Props.tag') || ''}`
                : `[${col.Header || 'Col'}]${tag}`
              if (_.get(col, 'meta.subCtrl.Type') === 'PowerTable') {
                el = {
                  type: 'PowerTable',
                  props: {
                    subTag,
                    ..._.get(col, 'meta.subCtrl.Props', {}),
                  },
                }
              } else {
                el = {
                  type: 'Widget',
                  props: {
                    subTag,
                    data: _.get(col, 'meta.subCtrl', {}),
                  },
                }
              }
              let elID = id
              if (String(id).indexOf('##') !== -1) {
                elID = _.first(String(id).split('##'))
              }
              ret = [
                ...ret,
                ...getElementActions(
                  el,
                  `${id}##${col.id}`,
                  uid,
                  page,
                  isRepeat,
                  isRepeatCol,
                  repeatUID,
                  repeatLabel,
                  isExport,
                  filterType,
                  state,
                  device
                ),
              ]
            }
          } else {
            _.each(_.get(col, 'columns', []), processColumn)
          }
        }

        _.each(child?.props?.columns, processColumn)
      } else if (['RepeatAutoFit'].includes(child?.type)) {
        let typeKey = child?.type
        const repeatLabel = `[Rep.AutoFit]${tag ? ` ${tag}` : tag}`
        if (!isExport) {
          push(`${valueStart}:${id}`, uid, `[${typeKey}]${tag}`, child.type)
          _.each(filterEditableParametersJS(_.get(child, ['props', 'params'], [])), function (param) {
            push(`${valueStart}:${param.id}`, uid, buildElementLabel(tag, `[Rep.AutoFit]`, param.name), child.type)
          })
        }
        _.each(_.get(child, 'children', []), (childUID) => {
          if (childUID === id) {
            return []
          }
          const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
          if (_.isArray(elem.children)) {
            elem.children = _.filter(elem.children, (child) => {
              if (_.isArray(child)) {
                return _.filter(child, (id) => id !== childUID)
              } else {
                return child !== childUID
              }
            })
          }
          ret = [
            ...ret,
            ...getElementActions(
              elem,
              childUID,
              uid,
              page,
              true,
              false,
              id,
              repeatLabel,
              isExport,
              (filterType = null),
              state,
              device
            ),
          ]
        })
      } else if (
        [
          'Tab',
          'Stepper',
          'MultiStepper',
          'Accordion',
          'PageConditionalForm',
          'ConditionalForm',
          'CarouselContainer',
        ].includes(child?.type)
      ) {
        let typeKey = child?.type
        if (!isExport) {
          push(`${valueStart}`, uid, `[${typeKey}]${tag}`, child.type)
          push(`${valueStart}-tabsList`, uid, `[${typeKey} / Items]${tag}`, child.type, `${valueStart}`, true)
          if (_.get(child, ['props', 'source'], 'static') === 'static') {
            push(
              `${valueStart}:ftListValue`,
              uid,
              buildElementLabel(tag, `${typeKey}`, 'Value'),
              child.type,
              `${valueStart}`
            )
            push(
              `${valueStart}:ftListLabel`,
              uid,
              buildElementLabel(tag, `${typeKey}`, 'Label'),
              child.type,
              `${valueStart}`
            )
            _.each(child.props.lg.tabs, (tab) => {
              push(
                `${valueStart}-tab:${fixActionID(tab.id)}`,
                uid,
                buildElementLabel(tag, `${typeKey}`, `${tab.label} / ${tab.ftValue || tab.id}`),
                child.type,
                `${valueStart}-tabsList`
              )
            })
          } else {
            push(
              `${valueStart}:ftListValue`,
              uid,
              buildElementLabel(tag, `${typeKey}`, 'Selected'),
              child.type,
              `${valueStart}`
            )
            // push(`${valueStart}:ftListLabel`, uid, `[Tab / Label]${tag}`, child.type)
            // let tab = _.first(_.get(child, 'props.lg.tabs', []))
            // push(`${valueStart}-tab:${tab.id}`, uid, `[Tab / Dynamic]${tag}`, child.type)
          }
        }

        if (_.get(child, ['props', 'source'], 'static') === 'static') {
          _.each(_.get(child, 'props.lg.tabs', []), (tab) => {
            _.each(tab.children, (childUID) => {
              if (childUID === id) {
                return []
              }
              const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
              if (_.isArray(elem.children)) {
                elem.children = _.filter(elem.children, (child) => {
                  if (_.isArray(child)) {
                    return _.filter(child, (id) => id !== childUID)
                  } else {
                    return child !== childUID
                  }
                })
              }
              ret = [
                ...ret,
                ...getElementActions(
                  elem,
                  childUID,
                  uid,
                  page,
                  isRepeat,
                  isRepeatCol,
                  repeatUID,
                  repeatLabel,
                  isExport,
                  (filterType = null),
                  state,
                  device
                ),
              ]
            })
          })
        } else {
          let tab = _.first(_.get(child, 'props.lg.tabs', []))
          _.each(tab.children, (childUID) => {
            if (childUID === id) {
              return []
            }
            const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
            if (_.isArray(elem.children)) {
              elem.children = _.filter(elem.children, (child) => {
                if (_.isArray(child)) {
                  return _.filter(child, (id) => id !== childUID)
                } else {
                  return child !== childUID
                }
              })
            }
            ret = [
              ...ret,
              ...getElementActions(
                elem,
                childUID,
                uid,
                page,
                isRepeat,
                isRepeatCol,
                repeatUID,
                repeatLabel,
                isExport,
                (filterType = null),
                state,
                device
              ),
            ]
          })
        }
      } else {
        if (!isExport) {
          push(`${valueStart}`, uid, buildElementLabel(tag, getDisplayType(child.type)), child.type)
        }
      }
    }

    if (child.type === 'Widget') {
      const rawTag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      const subTag = _.get(child, 'props.subTag') ? `${_.get(child, 'props.subTag', '')} / ` : ``
      const tag = rawTag ? ` ${rawTag}` : ''
      if (isExport) {
        if (['list', 'table', 'chart'].indexOf(_.get(child, 'props.data.Type')) !== -1) {
          push(
            `${valueStart}`,
            uid,
            buildElementLabel(tag, getDisplayType(_.get(child, 'props.data.Type'))),
            child.type
          )
        }
      } else {
        push(
          `${valueStart}`,
          uid,
          buildElementLabel(tag, `${subTag}${getDisplayType(_.get(child, 'props.data.Type'))}`),
          child.type
        )
        switch (_.get(child, 'props.data.Type')) {
          case 'table':
            push(`${valueStart}:row_style`, 'row_style', buildElementLabel(tag, 'Table', 'Row Style'), 'rowStyle')
            _.each(_.get(child, 'props.data.Props.mapping', []), (field) => {
              push(
                `${valueStart}:${field.id}`,
                `tableField:${field.key}`,
                buildElementLabel(tag, 'Table', `Col  / ${field.label}`),
                'tableField'
              )
              if (field.actionType || field.role == 'action') {
                push(
                  `${valueStart}:link:${field.id}`,
                  `link:${field.id}`,
                  buildElementLabel(tag, 'Table', 'Action'),
                  'link'
                )
              }
              push(
                `${valueStart}:fieldStyle:${field.id}`,
                `fieldStyle:${field.id}`,
                buildElementLabel(tag, 'Table', `Cell Style / ${field.label}`),
                'fieldStyle'
              )
            })
            break
          case 'list':
            push(
              `${valueStart}:list_row_style`,
              'list_row_style',
              buildElementLabel(tag, `${subTag}List`, `Row Style`),
              'listRowStyle'
            )

            _.map(_.get(child, 'props.data.Props.columns', []), (field) => {
              // push(`${valueStart}:${field.id}`, `field:${field.id}`, tag + ' / Field: ' + field.label, 'listWidget:' + id)

              push(
                `${valueStart}:${field.id}`,
                `listField:${field.id}`,
                buildElementLabel(tag, `${subTag}List`, field.label),
                'listField'
              )

              push(
                `${valueStart}:listFieldStyle:${field.id}`,
                `listFieldStyle:${field.id}`,
                buildElementLabel(tag, `${subTag}List`, `Cell Style / ${field.label}`),
                'listFieldStyle'
              )
            })
        }
      }
    }
    if (
      ![
        'Tab',
        'Stepper',
        'MultiStepper',
        'Accordion',
        'PageConditionalForm',
        'ConditionalForm',
        'RepeatAutoFit',
      ].includes(child?.type)
    ) {
      _.each(_.flatten(child.children), (childUID) => {
        if (childUID === id) {
          return []
        }
        const elem = page.getIn(['Props', 'elements', childUID], Map()).toJS()
        if (_.isArray(elem.children)) {
          elem.children = _.filter(elem.children, (child) => {
            if (_.isArray(child)) {
              return _.filter(child, (id) => id !== childUID)
            } else {
              return child !== childUID
            }
          })
        }
        ret = [
          ...ret,
          ...getElementActions(
            elem,
            childUID,
            uid,
            page,
            isRepeat,
            isRepeatCol,
            repeatUID,
            repeatLabel,
            isExport,
            filterType,
            state,
            device
          ),
        ]
      })
    }
  }

  return ret
}

const getPageActionTargets = (page, uid, isExport = false, type = null, state, device = 'lg') => {
  let rootElems = page.getIn(['Props', 'Grid'], List())
  let ret = []
  rootElems.map((id) => {
    const elem = page.getIn(['Props', 'elements', id], Map()).toJS()
    const isRepeat = _.get(elem, 'props.isRepeat', false)
    const isRepeatCol = _.get(elem, 'props.isRepeatCol', false)
    const rawTag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
    const tag = rawTag ? ` ${rawTag}` : ''

    ret = [
      ...ret,
      ...getElementActions(
        elem,
        id,
        uid,
        page,
        isRepeat,
        isRepeatCol,
        id,
        `[Repeat${isRepeatCol ? ' Col' : ''}]${tag}`,
        isExport,
        type,
        state,
        device
      ),
    ]
  })
  return ret
}

const getProjectActions = (key, elements) => {
  let ret = []
  elements
    .filter((elem) => elem.get('parent') === key)
    .map((val, id) => {
      const elem = val.toJS()
      const isRepeat = false
      const isRepeatCol = false
      const rawTag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
      const tag = rawTag ? ` ${rawTag}` : ''

      ret = [
        ...ret,
        ...getElementActions(
          elem,
          id,
          key,
          Map(),
          isRepeat,
          isRepeatCol,
          id,
          `[Repeat${isRepeatCol ? ' Col' : ''}]${tag}`
        ),
      ]
    })

  return ret
}

const processMenuActions = (menu, target, parent = null) => {
  let actions = []
  const push = (value, uid, text) =>
    actions.push({
      value,
      uid,
      text: `${target} / ${text}`,
      type: 'menu',
    })
  menu.map((item) => {
    push(`${parent}:${item.get('id')}`, item.get('id'), item.get('Text'))
    if (item.get('isFolder')) {
      item.get('children', List()).map((child) => {
        push(`${parent}:${child.get('id')}`, child.get('id'), child.get('Text'))
      })
    }
  })
  return actions
}

let prev = null
let results = null
let prevExport = null
let prevType = null
let condVarHash = null
export const getConditionsActionTargetCache = (state, isExport = false, type = null) => {
  if (
    prev === null ||
    results === null ||
    Date.now() - prev > 2000 ||
    prevExport !== isExport ||
    prevType !== type ||
    condVarHash !== getVarHash(state)
  ) {
    prev = Date.now()
    prevExport = isExport
    prevType = type
    condVarHash = getVarHash(state)
    results = getConditionsActionTarget(state, isExport, type)
  }
  return results
}

export const getConditionsActionTarget = (state, isExport = false, type = null) => {
  let ret = []
  if (!isExport && type === null) {
    ret = filterEditableParameters(state.getIn(['project', 'Settings', 'params'], List()), false, true)
      .map((param) => ({
        value: param.get('id'),
        uid: param.get('id'),
        text: `[GV / ${param.get('name')}]`,
        type: 'param',
      }))
      .toJS()
  }

  const pageParams = state.getIn(['pages'], Map()).reduce((ret, page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage && type === null) {
      return _.concat(
        ret,
        filterEditableParameters(page.getIn(['Props', 'params'], List()))
          .map((param) => ({
            value: `${projectPage.get('uid')}:${param.get('id')}`,
            uid: param.get('id'),
            text: `[PV / ${projectPage.get('name', 'NoName')} / ${param.get('name')}]`,
            type: 'pageParam',
          }))
          .toJS()
      )
    } else {
      return ret
    }
  }, [])

  const pagesActions = []
  // const pagesActions = state.getIn(['project', 'Pages'], List())
  //     .map(page => ({
  //         value: page.get('uid'),
  //         uid: page.get('uid'),
  //         text: `[Page / ${page.get('name', 'No name')}]`,
  //         type: 'page'
  //     }))
  //     .toJS()

  let projectActions = []
  let drawerActions = []
  if (state.getIn(['project', 'Settings', 'Header', 'enable'], false) && type === null) {
    const elems = getProjectActions('Header', state.getIn(['project', 'Settings', 'elements'], Map()))
    projectActions = _.concat(projectActions, elems)
    const menu = state.getIn(['project', 'Settings', 'Header', 'Menu'], List())
    const profileMenu = state.getIn(['project', 'Settings', 'Header', 'ProfileMenu'], List())
    drawerActions = [
      ...drawerActions,
      ...processMenuActions(menu, 'Header', 'HeaderMenu'),
      ...processMenuActions(profileMenu, 'Header', 'HeaderMenu'),
    ]
  }
  if (state.getIn(['project', 'Settings', 'Drawer', 'enable'], false) && type === null) {
    const menu = state.getIn(['project', 'Settings', 'Drawer', 'Menu'], List())
    drawerActions = [...drawerActions, ...processMenuActions(menu, 'Drawer', 'DrawerMenu')]
  }
  if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
    const elems = getProjectActions(
      'Footer',
      state
        .getIn(['project', 'Settings', 'elements'], Map())
        .filter((elem) => (type === null ? true : elem.get('type') === type))
    )
    projectActions = _.concat(projectActions, elems)
    const menu = state.getIn(['project', 'Settings', 'Footer', 'Menu'], List())
    drawerActions = [...drawerActions, ...processMenuActions(menu, 'Footer', 'FooterMenu')]
  }

  let elemsActions = []

  const processUIelem = (id) => {
    const elem = state.getIn(['project', 'Settings', 'elements', id], Map()).toJS()
    const rawTag = _.get(elem, 'props.tag') ? _.get(elem, 'props.tag') : ''
    const tag = rawTag ? ` ${rawTag}` : ''

    let fakePage = fromJS({
      Props: {
        elements: state.getIn(['project', 'Settings', 'elements'], Map()),
      },
    })

    const customActions = []

    if (elem.type === 'Modal') {
      customActions.push({
        value: `${id}-title`,
        uid: id,
        text: `[Modal] ${rawTag || ''} / Title`,
        type: 'Modal',
      })

      if (elem.props.isExp) {
        _.each(elem?.props?.lg?.tabs, (tab) => {
          customActions.push({
            value: `${id}-tabs:${tab.id}`,
            uid: id,
            text: `[Modal] ${rawTag || ''} / ${tab.label}`,
            type: 'Modal',
          })
        })

        // _.each(tab.children, processUIelem)
      }
    }

    elemsActions = [
      ...elemsActions,
      ...customActions,
      ...getElementActions(
        elem,
        id,
        ['Modal', 'DrawerEl'].includes(elem.type) ? id : 'project',
        fakePage,
        false,
        false,
        id,
        `${tag}`,
        isExport,
        type,
        state,
        state.get('layoutMode', 'lg')
      ),
    ]
  }
  state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(processUIelem)
  state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(processUIelem)

  state.getIn(['project', 'Pages'], List()).map((pageRec) => {
    const uid = pageRec.get('uid')

    const elems = getPageActionTargets(
      state.getIn(['pages', pageRec.get('_id')], Map()),
      uid,
      isExport,
      type,
      state,
      state.get('layoutMode', 'lg')
    )
    elemsActions = [...elemsActions, ...elems]
  })

  // state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map(uid => {
  //     const elem = state.getIn(['project', 'Settings', 'elements', uid], Map()).toJS()
  //     let fakePage = fromJS({
  //         Props: {
  //             elements: state.getIn(['project', 'Settings', 'elements'], Map())
  //         }
  //     })
  //     elemsActions = [
  //         ...elemsActions,
  //         ...getElementActions(
  //             elem, uid, uid, fakePage, false, false, null, '', isExport, type, state, state.get('layoutMode', 'lg')
  //         )
  //     ]
  // })
  // state.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(uid => {
  //     const elem = state.getIn(['project', 'Settings', 'elements', uid], Map()).toJS()
  //     let fakePage = fromJS({
  //         Props: {
  //             elements: state.getIn(['project', 'Settings', 'elements'], Map())
  //         }
  //     })
  //     elemsActions = [
  //         ...elemsActions,
  //         ...getElementActions(
  //             elem, uid, uid, fakePage, false, false, null, '', isExport, type, state, state.get('layoutMode', 'lg')
  //         )
  //     ]
  // })

  if (isExport) {
    return _.uniqBy([...ret, ...elemsActions], 'value')
  }

  return _.uniqBy(
    [...ret, ...pageParams, ...pagesActions, ...projectActions, ...drawerActions, ...elemsActions],
    'value'
  )
}

export const getPanelPositionOnShow = (panels, isRTL, pos) => {
  let left
  let right
  if (!pos) {
    pos = 10
  }
  if (isRTL) {
    left = panels.get('left', 40 + pos + 'px')
    right = panels.get('right', 'unset')
  } else {
    left = panels.get('left', 'unset')
    right = panels.get('right', pos + 'px')
  }
  if (left != 'unset') {
    if (parseInt(left) > window.innerWidth) {
      left = 'unset'
      right = pos + 'px'
    }
  }
  let top = parseInt(panels.get('top', '60px'))
  if (isNaN(top)) {
    top = '60px'
  } else if (top > window.innerHeight) {
    top = '60px'
  } else {
    top += 'px'
  }
  return {
    top: top,
    right,
    left,
  }
}

export const getProjectLoopElements = (state) => {
  const option = (label, value, type) => ({ label, value, type })
  let params = [option('None', '')]

  state.getIn(['project', 'Settings', 'params'], List()).map((param) => {
    params.push(option(`[GV / ${param.get('name')}]`, param.get('id'), 'param'))
  })

  state.getIn(['pages'], Map()).map((page, pageID) => {
    const projectPage = state
      .getIn(['project', 'Pages'], List())
      .find((projectPage) => projectPage.get('_id') === pageID)
    if (projectPage) {
      page.getIn(['Props', 'params'], List()).map((param) => {
        params.push(option(`[PV / ${param.get('name')}]`, `${projectPage.get('uid')}:${param.get('id')}`, 'param'))
      })
    }
  })

  const processElem = (child, id, uid, page) => {
    if (child.type === 'Strip') {
      const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
      const isRepeat = _.get(child, 'props.isRepeat', false)
      const isRepeatCol = _.get(child, 'props.isRepeatCol', false)
      const repeatLabel = `[Repeat${isRepeatCol ? ' Col' : ''}]${tag ? ` ${tag}` : tag}`
      if (isRepeat || isRepeatCol) {
        params.push(option(buildElementLabel(tag, repeatLabel), `${uid}:${id}`, 'Strip'))
      }
    }
  }

  state.getIn(['project', 'Pages'], List()).map((projectPage) => {
    const uid = projectPage.get('uid')
    const page = state.getIn(['pages', projectPage.get('_id')], Map())
    const rootElems = page.getIn(['Props', 'Grid'], List())

    rootElems.map((id) => {
      const elem = page.getIn(['Props', 'elements', id], Map()).toJS()
      processElem(elem, id, uid, page)
    })
    page.getIn(['Props', 'elements'], Map()).map((elem, id) => {
      if (elem.get('type') === 'PowerTable') {
        const child = elem.toJS()
        const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
        params.push(option(buildElementLabel(tag, '[PowerTable]'), `${uid}:${id}`, 'PowerTable'))
      } else if (elem.get('type') === 'FormField' && elem.getIn(['props', 'control']) === 'number') {
        const child = elem.toJS()
        const tag = _.get(child, 'props.tag') ? _.get(child, 'props.tag') : ''
        params.push(option(buildElementLabel(tag, '[FormField]'), `${uid}:${id}`, 'FormField'))
      }
    })
  })

  return _.uniqBy(params, (val) => val.value)
}

export const getProjectFormElements = (state, type = 'Form') => {
  let forms = [option('None', '')]

  const projectElements = state
    .getIn(['project', 'Settings', 'elements'], Map())
    .filter(
      (elem) =>
        elem.get('type') === type || (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === type)
    )

  projectElements.map((elem, uid) => {
    const rawTag = elem.getIn(['props', 'tag']) ? elem.getIn(['props', 'tag']) : ''
    const tag = rawTag ? ` ${rawTag}` : ''
    let parentType
    let parentId = getParentIdInModal(state, elem.get('parent'), true)
    if (elem.get('parent') === 'Footer') {
      parentType = 'Footer'
    } else {
      const parent = state.getIn(['project', 'Settings', 'elements', parentId]) || Map()
      parentType = getDisplayType(parent.get('type', elem.get('parent')))
    }
    const formEl = option(`[${type} / ${parentType}]${tag}`, `${parentId || 'project'}:${uid}`)
    formEl.isRepeat = false
    let isNeedPushElem = true
    if (!state.getIn(['project', 'Settings', 'Footer', 'enable'], false) && parentId == 'Footer') {
      isNeedPushElem = false
    }
    if (isNeedPushElem) {
      forms.push(formEl)
    }
  })

  const pages = state.getIn(['project', 'Pages'], List())

  pages.map((page) => {
    const pageElements = state
      .getIn(['pages', page.get('_id'), 'Props', 'elements'], Map())
      .filter(
        (elem) =>
          elem.get('type') === type || (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === type)
      )
    let allPageElements = state.getIn(['pages', page.get('_id'), 'Props', 'elements'], Map())
    pageElements.map((elem, uid) => {
      const rawTag = elem.getIn(['props', 'tag']) ? elem.getIn(['props', 'tag']) : ''
      const tag = rawTag ? ` ${rawTag}` : ''
      if (type === 'Strip') {
        let formEl = option(`[${type}]${tag}`, `${page.get('uid')}:${uid}`)
        if (elem.getIn(['props', 'isRepeat'], false)) {
          formEl = option(`[Repeat Strip]${tag}`, `${page.get('uid')}:${uid}`)
        } else if (elem.getIn(['props', 'isRepeatCol'], false)) {
          formEl = option(`[Repeat Column]${tag}`, `${page.get('uid')}:${uid}`)
        }
        formEl.isRepeat = elem.getIn(['props', 'isRepeat'], false) || elem.getIn(['props', 'isRepeatCol'], false)
        forms.push(formEl)
      } else {
        let parent = getRootParent(uid, allPageElements)

        let key = `${page.get('uid')}:${uid}`
        if (parent) {
          if (
            allPageElements.getIn([parent, 'props', 'isRepeat']) ||
            allPageElements.getIn([parent, 'props', 'isRepeatCol'])
          ) {
            key = `${page.get('uid')}:${parent}:${uid}`
          }
        }
        const formEl = option(`[${type}]${tag}`, key)
        forms.push(formEl)
      }
    })
  })

  return _.uniqBy(forms, (val) => val.value)
}

export const getProjectStripElements = (state) => {
  let forms = [option('None', '')]

  const projectElements = state.getIn(['project', 'Settings', 'elements'], Map()).filter((elem) => {
    return elem.get('type') === 'Strip'
  })

  projectElements.map((elem, uid) => {
    const rawTag = elem.getIn(['props', 'tag']) ? elem.getIn(['props', 'tag']) : ''
    const tag = rawTag ? ` ${rawTag}` : ''
    const formEl = option(`[Strip]${tag}`, `${elem.get('parent')}:${uid}`)
    forms.push(formEl)
  })

  const pages = state.getIn(['project', 'Pages'], List())

  pages.map((page) => {
    const pageElements = state.getIn(['pages', page.get('_id'), 'Props', 'elements'], Map()).filter((elem) => {
      return elem.get('type') === 'Strip'
    })
    pageElements.map((elem, uid) => {
      const rawTag = elem.getIn(['props', 'tag']) ? elem.getIn(['props', 'tag']) : ''
      const tag = rawTag ? ` ${rawTag}` : ''
      let formEl = option(`[Strip]${tag}`, `${page.get('uid')}:${uid}`)
      if (elem.getIn(['props', 'isRepeat'], false)) {
        formEl = option(`[Repeat Strip]${tag}`, `${page.get('uid')}:${uid}`)
      } else if (elem.getIn(['props', 'isRepeatCol'], false)) {
        formEl = option(`[Repeat Column]${tag}`, `${page.get('uid')}:${uid}`)
      }
      forms.push(formEl)
    })
  })

  return forms
}
